// css
import "./addNewBoat.css";
import "./responsive.css";
// others
import { ArrowBack } from "@material-ui/icons";
import { useState } from "react";
import { withRouter } from "react-router-dom";
import CustomInput from "Utills/CustomInput/CustomInput";
import { connect } from "react-redux";
import NotLoggedIn from "Components/notLoggedIn";
import SiginInPopup from "Components/Popup/SiginInPopup/SiginInPopup";
import CustomModel from "Utills/Model/CustomModel";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import PlusImg from "assets/Images/icons/plusImg.png";
import PickImageBtn from "Utills/PickImageBtn";
import crew_icon from "assets/Images/icons/crew.png";
import { useNotifyContext } from "context/notifyContext";
import { Close } from "@material-ui/icons";
import { DateRangePicker } from "react-date-range";

//============ will return class according to mode easy || medium || hard  ============
const modeClass = (mode) => {
  if (mode === "0") {
    return "easy";
  } else if (mode === "1") {
    return "medium";
  } else if (mode === "2") {
    return "strict";
  }
};

//======================== THIS IS A ADD NEW BOAT PAGE WITH STEPS FORMS ==================
const AddBoat = (props) => {
  // notifications alerts state
  const { set_notify, loading } = useNotifyContext();
  //
  const [showPopup, setShowPopup] = useState(false);
  //================= active state ===================
  const [activeStep, setActiveStep] = useState(4);
  // ============= form data state =========================
  const [formData, setFormData] = useState({
    pets_allowed: true,
    crew_allowed: false,
    parties_allowed: false,
    description: "",
    gallery_imgs: { 0: {}, 1: {}, 2: {} },
    insurance_file: {},
    intraDay: true,
    overNight: false,
    flexible_intraDay: true,
    intraday_flexible_mode: "0",
    overnight_flexible_mode: "2",
    flexible_overnight: true,
  });
  //   **********************************************************
  //========================== features list  ===============================
  const featuresDataList = {
    0: {
      title: "Tv",
      name: "tv",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="35"
          height="34"
          viewBox="0 0 35 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.92692 5.6665C5.86329 5.6665 4.84323 6.07696 4.09113 6.80757C3.33903 7.53818 2.9165 8.5291 2.9165 9.56234V21.604C2.9165 22.6372 3.33903 23.6282 4.09113 24.3588C4.84323 25.0894 5.86329 25.4998 6.92692 25.4998H28.0728C29.1364 25.4998 30.1564 25.0894 30.9085 24.3588C31.6606 23.6282 32.0832 22.6372 32.0832 21.604V9.56234C32.0832 8.5291 31.6606 7.53818 30.9085 6.80757C30.1564 6.07696 29.1364 5.6665 28.0728 5.6665H6.92692ZM5.104 9.56234C5.104 8.58484 5.92067 7.7915 6.92692 7.7915H28.0728C29.079 7.7915 29.8957 8.58484 29.8957 9.56234V21.604C29.8957 22.5815 29.079 23.3748 28.0728 23.3748H6.92692C5.92067 23.3748 5.104 22.5815 5.104 21.604V9.56234ZM8.38525 27.6248C8.09517 27.6248 7.81697 27.7368 7.61186 27.936C7.40674 28.1353 7.2915 28.4055 7.2915 28.6873C7.2915 28.9691 7.40674 29.2394 7.61186 29.4386C7.81697 29.6379 8.09517 29.7498 8.38525 29.7498H26.6144C26.9045 29.7498 27.1827 29.6379 27.3878 29.4386C27.5929 29.2394 27.7082 28.9691 27.7082 28.6873C27.7082 28.4055 27.5929 28.1353 27.3878 27.936C27.1827 27.7368 26.9045 27.6248 26.6144 27.6248H8.38525Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    1: {
      title: "Dinghy",
      name: "dinghy",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.7185 6.44251C9.0106 6.44277 9.29988 6.38546 9.56982 6.27386C9.83976 6.16227 10.0851 5.99856 10.2917 5.79211C10.4983 5.58566 10.6623 5.34051 10.7741 5.07067C10.8859 4.80084 10.9435 4.5116 10.9435 4.21951C10.9434 3.92759 10.8858 3.63856 10.7739 3.36895C10.662 3.09933 10.498 2.85444 10.2913 2.64828C10.0847 2.44212 9.83937 2.27875 9.56948 2.16751C9.29959 2.05627 9.01041 1.99935 8.7185 2.00001C8.42662 1.99955 8.13751 2.0566 7.86768 2.1679C7.59785 2.2792 7.3526 2.44258 7.14593 2.64869C6.93926 2.8548 6.77522 3.09962 6.66319 3.36914C6.55116 3.63867 6.49333 3.92762 6.493 4.21951C6.4934 4.80939 6.72808 5.37497 7.14542 5.79185C7.56277 6.20873 8.12861 6.44277 8.7185 6.44251ZM0.5 18.5835C1 18.5835 1.5245 18.4635 1.9735 18.262C2.45117 18.0407 2.97107 17.9254 3.4975 17.924C4.02301 17.9251 4.54199 18.0404 5.0185 18.262C5.48495 18.4707 5.99 18.5792 6.501 18.5805C7.01026 18.5794 7.51356 18.4709 7.978 18.262C8.45509 18.04 8.97481 17.9247 9.501 17.924C10.0268 17.9257 10.5459 18.041 11.023 18.262C11.4874 18.4709 11.9907 18.5795 12.5 18.5805C13.0235 18.5805 13.53 18.4635 13.9765 18.262C14.4547 18.0408 14.9751 17.9255 15.502 17.924C16.043 17.924 16.5605 18.049 17.0215 18.262C17.4873 18.4705 17.9917 18.579 18.502 18.5805C19.027 18.5805 19.5295 18.4635 19.9815 18.262C20.4241 18.056 20.9038 17.9417 21.3917 17.926C21.8796 17.9104 22.3657 17.9937 22.8205 18.171C23.5075 17.4275 23.8897 16.4528 23.8915 15.4405C23.8915 13.2035 22.076 11.3925 19.8365 11.3925L19.382 11.441C18.8835 13.4595 16.86 13.5445 16.86 13.5445L7.6 13.542L6.826 13.0875L8.6925 9.96251L10.736 11.1405C11.9595 11.932 12.5965 10.8225 12.5965 10.8225L14.6455 7.48951C15.536 6.04151 13.647 4.88051 12.762 6.33401L11.3275 8.67001L7.9185 6.78801C5.556 5.47351 4.555 7.65101 4.555 7.65101L1.8775 12.227C1.422 13.178 1.8255 13.5865 1.8255 13.5865L0.5 13.5845V18.5835ZM24.5 23C23.9917 22.9997 23.4892 22.8913 23.026 22.682C22.5478 22.4608 22.0274 22.3457 21.5005 22.3445C20.9757 22.3454 20.4573 22.4606 19.9815 22.682C19.5162 22.8909 19.012 22.9992 18.502 23C17.9916 22.9991 17.4872 22.8908 17.0215 22.682C16.5454 22.4609 16.027 22.3457 15.502 22.3445C14.9751 22.3458 14.4548 22.4609 13.9765 22.682C13.5124 22.8913 13.0091 22.9997 12.5 23C11.9907 22.9996 11.4873 22.8912 11.023 22.682C10.5459 22.4612 10.0267 22.3461 9.501 22.3445C8.97501 22.3451 8.45546 22.4603 7.9785 22.682C7.5141 22.891 7.01075 22.9994 6.5015 23C5.99047 22.9994 5.48532 22.891 5.019 22.682C4.54281 22.4606 4.02415 22.3454 3.499 22.3445C2.97324 22.3457 2.45398 22.4608 1.977 22.682C1.5126 22.891 1.00925 22.9994 0.5 23V20.7915C1.00946 20.7899 1.51281 20.6805 1.977 20.4705C2.45408 20.2496 2.97327 20.1345 3.499 20.133C4.04 20.133 4.561 20.258 5.019 20.4705C5.48519 20.6803 5.99029 20.7896 6.5015 20.7915C7.01096 20.7899 7.51431 20.6805 7.9785 20.4705C8.45554 20.249 8.97504 20.1338 9.501 20.133C10.0415 20.133 10.559 20.258 11.023 20.4705C11.4872 20.6805 11.9905 20.7899 12.5 20.7915C13.0093 20.7902 13.5126 20.6808 13.9765 20.4705C14.4548 20.2497 14.9752 20.1346 15.502 20.133C16.043 20.133 16.5605 20.258 17.0215 20.4705C17.4871 20.68 17.9915 20.7894 18.502 20.7915C19.027 20.7915 19.5295 20.6725 19.9815 20.4705C20.4574 20.2493 20.9757 20.1342 21.5005 20.133C22.044 20.133 22.5625 20.258 23.026 20.4705C23.473 20.672 23.976 20.7915 24.5 20.7915V23Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    2: {
      title: "Wifi",
      name: "wifi",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="32"
          height="24"
          viewBox="0 0 32 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M28.4209 10.7557C28.1722 10.7557 27.9337 10.6569 27.7579 10.481C24.6173 7.34042 20.4416 5.6108 16 5.6108C11.5584 5.6108 7.38277 7.34042 4.24209 10.4811C4.06627 10.6569 3.82784 10.7557 3.57921 10.7557C3.33059 10.7557 3.09215 10.6569 2.91634 10.4811L0.274593 7.83948C-0.0915311 7.47336 -0.0915311 6.8798 0.274593 6.51367C2.39721 4.39105 4.87252 2.74743 7.63183 1.6285C10.2966 0.547874 13.112 0 16 0C18.8879 0 21.7034 0.547936 24.3681 1.6285C27.1274 2.74743 29.6028 4.39105 31.7254 6.51367C32.0915 6.87974 32.0915 7.47336 31.7254 7.83948L29.0838 10.4811C28.908 10.6569 28.6695 10.7557 28.4209 10.7557Z"
            fill="#1A4D6D"
          />
          <path
            d="M22.9489 16.2078C22.7002 16.2078 22.4618 16.109 22.286 15.9332C20.607 14.2542 18.3747 13.3296 16.0003 13.3296C13.6259 13.3296 11.3936 14.2542 9.71462 15.9332C9.53881 16.109 9.30038 16.2078 9.05175 16.2078C8.80306 16.2078 8.56463 16.109 8.38881 15.9332L5.74719 13.2916C5.38113 12.9254 5.38113 12.3319 5.74726 11.9657C8.48594 9.227 12.1272 7.71875 16.0004 7.71875C19.8735 7.71875 23.5148 9.227 26.2535 11.9657C26.6195 12.3319 26.6196 12.9254 26.2535 13.2916L23.6119 15.9332C23.436 16.109 23.1975 16.2078 22.9489 16.2078Z"
            fill="#1A4D6D"
          />
          <path
            d="M16.0001 23.216C13.8574 23.216 12.1143 21.4901 12.1143 19.3687C12.1143 17.2474 13.8574 15.5215 16.0001 15.5215C18.1427 15.5215 19.8859 17.2474 19.8859 19.3687C19.8859 21.4901 18.1427 23.216 16.0001 23.216Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    3: {
      title: "Security system",
      name: "security_system",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="28"
          height="25"
          viewBox="0 0 28 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.25 12.9609L9.98375 10.9375L8.75 12.0391L12.25 15.1641L19.25 8.91406L18.0163 7.8125L12.25 12.9609Z"
            fill="black"
          />
          <path
            d="M14 23.4375L8.59601 20.8648C7.05542 20.1331 5.7671 19.0405 4.86931 17.7045C3.97152 16.3684 3.49815 14.8393 3.50001 13.2812V3.125C3.50047 2.71073 3.68499 2.31354 4.01308 2.0206C4.34117 1.72767 4.78602 1.56291 5.25001 1.5625H22.75C23.214 1.56291 23.6588 1.72767 23.9869 2.0206C24.315 2.31354 24.4995 2.71073 24.5 3.125V13.2812C24.5019 14.8393 24.0285 16.3684 23.1307 17.7045C22.2329 19.0405 20.9446 20.1331 19.404 20.8648L14 23.4375ZM5.25001 3.125V13.2812C5.24855 14.5561 5.63597 15.8072 6.37067 16.9004C7.10538 17.9935 8.15962 18.8873 9.42025 19.4859L14 21.6664L18.5798 19.4867C19.8405 18.888 20.8948 17.9941 21.6296 16.9008C22.3643 15.8075 22.7516 14.5562 22.75 13.2812V3.125H5.25001Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    4: {
      title: "Ac",
      name: "ac",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="32"
          height="29"
          viewBox="0 0 32 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M29.3332 13.2915H23.7732L28.0932 9.3765L26.2132 7.66067L19.9998 13.2915H17.3332V10.8748L23.5465 5.244L21.6532 3.54025L17.3332 7.45525V2.4165H14.6665V7.45525L10.3465 3.54025L8.45317 5.244L14.6665 10.8748V13.2915H11.9998L5.7865 7.66067L3.9065 9.3765L8.2265 13.2915H2.6665V15.7082H8.2265L3.9065 19.6232L5.7865 21.339L11.9998 15.7082H14.6665V18.1248L8.45317 23.7557L10.3465 25.4594L14.6665 21.5444V26.5832H17.3332V21.5444L21.6532 25.4594L23.5465 23.7557L17.3332 18.1248V15.7082H19.9998L26.2132 21.339L28.0932 19.6232L23.7732 15.7082H29.3332V13.2915Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    5: {
      title: "Warm water",
      name: "warm_water",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="23"
          height="24"
          viewBox="0 0 23 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.755 19.2129C20.1291 19.1986 19.5221 19.4371 19.0607 19.8785L18.3906 20.5297C18.2008 20.7244 17.9453 20.8334 17.6791 20.8334C17.413 20.8334 17.1575 20.7244 16.9677 20.5297C16.7545 20.3393 16.5552 20.1169 16.3405 19.9105C15.8652 19.4536 15.2426 19.2 14.5964 19.2C13.9501 19.2 13.3275 19.4536 12.8522 19.9105C12.6253 20.1169 12.4106 20.3553 12.1837 20.5617C11.9936 20.7565 11.7378 20.8656 11.4714 20.8656C11.205 20.8656 10.9493 20.7565 10.7592 20.5617C10.5323 20.3553 10.3176 20.1169 10.0907 19.9105C9.61596 19.4581 8.99629 19.2072 8.35339 19.2072C7.71049 19.2072 7.09082 19.4581 6.61612 19.9105C6.40299 20.1169 6.20366 20.3393 5.99052 20.5297C5.8645 20.6418 5.71937 20.7281 5.56272 20.7841C5.35623 20.8343 5.14045 20.8238 4.93934 20.7537C4.73822 20.6837 4.55965 20.5569 4.42346 20.3873C4.07269 20.0496 3.69688 19.7415 3.29952 19.4657C3.00879 19.2802 2.67063 19.192 2.33046 19.2129H2.24459C2.05951 19.2375 1.88937 19.3316 1.76606 19.4777C1.64274 19.6238 1.57471 19.8118 1.57471 20.0065C1.57471 20.2012 1.64274 20.3892 1.76606 20.5353C1.88937 20.6814 2.05951 20.7755 2.24459 20.8001C2.42199 20.8119 2.59518 20.8616 2.75343 20.9461C2.91168 21.0306 3.05162 21.1481 3.16459 21.2913L3.67672 21.7041C4.12963 22.1269 4.71148 22.3685 5.31894 22.3861C5.92641 22.4037 6.52019 22.1961 6.99486 21.8001C7.26472 21.5777 7.50699 21.2929 7.77686 21.0545C7.96694 20.8597 8.2227 20.7506 8.48909 20.7506C8.75549 20.7506 9.01124 20.8597 9.20132 21.0545L9.75639 21.6097C10.2202 22.0834 10.8378 22.3579 11.4865 22.3786C12.1353 22.3994 12.7678 22.1649 13.2585 21.7217C13.4732 21.5457 13.6434 21.3249 13.8565 21.1345C14.0405 20.918 14.2993 20.7864 14.5761 20.7687C14.8529 20.751 15.1252 20.8486 15.3331 21.0401L15.9802 21.6897C16.311 22.0095 16.7171 22.2323 17.1571 22.3354C17.5972 22.4386 18.0555 22.4184 18.4857 22.2769C19.0384 22.1059 19.5323 21.7726 19.9086 21.3169C20.1227 21.0449 20.4228 20.8616 20.755 20.8001C20.9401 20.7755 21.1102 20.6814 21.2335 20.5353C21.3568 20.3892 21.4249 20.2012 21.4249 20.0065C21.4249 19.8118 21.3568 19.6238 21.2335 19.4777C21.1102 19.3316 20.9401 19.2375 20.755 19.2129ZM11.4446 3.2753C10.8546 3.62676 10.3506 4.11595 9.97197 4.70456C9.59337 5.29316 9.35045 5.96522 9.26224 6.66812C9.17403 7.37102 9.24292 8.08568 9.46351 8.75616C9.68411 9.42665 10.0504 10.0348 10.5338 10.5329C10.8927 10.866 11.1613 11.2919 11.3126 11.7676C11.4639 12.2434 11.4925 12.7523 11.3955 13.2433C10.9156 14.6721 9.72419 16.0001 10.3866 17.6001C10.8251 16.0465 12.4827 15.5345 13.2401 14.2017C14.7581 11.6977 13.0025 9.4017 11.6608 7.4097C10.9539 5.3169 13.5299 3.7121 12.6115 1.6001C12.3923 2.26796 11.9857 2.85163 11.4446 3.2753ZM15.9618 5.6753C15.4506 6.45034 15.2488 7.40265 15.399 8.33035C15.5493 9.25805 16.0399 10.0882 16.7668 10.6449C17.0479 10.8138 17.2741 11.0667 17.4162 11.371C17.5583 11.6753 17.6098 12.017 17.5641 12.3521C17.075 13.5377 15.8959 14.6049 16.5123 16.0001C17.0857 14.6081 18.0701 14.9697 19.2983 13.5265C19.8123 12.7524 20.0167 11.7996 19.8681 10.8707C19.7194 9.94186 19.2296 9.11005 18.5025 8.5521C18.2194 8.38476 17.991 8.13255 17.8469 7.82814C17.7029 7.52374 17.6497 7.18118 17.6945 6.8449C18.1821 5.6593 19.3627 4.5953 18.7479 3.2001C18.1775 4.5921 17.19 4.2321 15.9618 5.6753ZM3.69512 5.6753C3.18394 6.45034 2.98209 7.40265 3.13237 8.33035C3.28264 9.25805 3.77322 10.0882 4.50012 10.6449C4.78124 10.8138 5.00744 11.0667 5.14955 11.371C5.29166 11.6753 5.34318 12.017 5.29746 12.3521C4.80832 13.5377 3.62919 14.6049 4.24559 16.0001C4.81906 14.6081 5.80346 14.9697 7.03166 13.5265C7.5456 12.7524 7.74999 11.7996 7.60138 10.8707C7.45278 9.94186 6.9629 9.11005 6.23586 8.5521C5.95276 8.38476 5.72436 8.13255 5.58028 7.82814C5.43619 7.52374 5.38307 7.18118 5.42779 6.8449C5.91539 5.6593 7.09606 4.5953 6.48119 3.2001C5.91079 4.5921 4.92332 4.2321 3.69512 5.6753Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    6: {
      title: "Heating",
      name: "heating",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="28"
          height="29"
          viewBox="0 0 28 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.91667 5.43734L6.3 11.479L9.91667 17.7623L6.06667 24.7707L3.96667 23.6832L7.11667 17.7623L3.5 11.479L7.81667 4.34984L9.91667 5.43734ZM17.15 5.3165L13.5333 11.479L17.15 17.5207L13.3 24.529L11.2 23.4415L14.35 17.5207L10.7333 11.479L15.05 4.229L17.15 5.3165ZM24.5 5.3165L20.8833 11.479L24.5 17.5207L20.65 24.529L18.55 23.4415L21.7 17.5207L18.0833 11.479L22.4 4.229L24.5 5.3165Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    7: {
      title: "VHF",
      name: "vhf",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="27"
          height="25"
          viewBox="0 0 27 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.1247 7.5C9.94569 7.5 9.774 7.56585 9.64741 7.68306C9.52082 7.80027 9.44971 7.95924 9.44971 8.125V11.875C9.44971 12.0408 9.52082 12.1997 9.64741 12.3169C9.774 12.4342 9.94569 12.5 10.1247 12.5H16.8747C17.0537 12.5 17.2254 12.4342 17.352 12.3169C17.4786 12.1997 17.5497 12.0408 17.5497 11.875V8.125C17.5497 7.95924 17.4786 7.80027 17.352 7.68306C17.2254 7.56585 17.0537 7.5 16.8747 7.5H10.1247ZM10.7997 11.25V8.75H16.1997V11.25H10.7997ZM10.7997 15.625C10.7997 15.4592 10.8708 15.3003 10.9974 15.1831C11.124 15.0658 11.2957 15 11.4747 15H15.5247C15.7037 15 15.8754 15.0658 16.002 15.1831C16.1286 15.3003 16.1997 15.4592 16.1997 15.625C16.1997 15.7908 16.1286 15.9497 16.002 16.0669C15.8754 16.1842 15.7037 16.25 15.5247 16.25H11.4747C11.2957 16.25 11.124 16.1842 10.9974 16.0669C10.8708 15.9497 10.7997 15.7908 10.7997 15.625Z"
            fill="#1A4D6D"
          />
          <path
            d="M10.7999 1.875C10.7999 1.70924 10.7288 1.55027 10.6022 1.43306C10.4756 1.31585 10.3039 1.25 10.1249 1.25C9.94588 1.25 9.77419 1.31585 9.64761 1.43306C9.52102 1.55027 9.4499 1.70924 9.4499 1.875V3.75H7.4249C6.88784 3.75 6.37277 3.94754 5.99301 4.29917C5.61325 4.65081 5.3999 5.12772 5.3999 5.625V14.375C5.40001 14.4982 5.43946 14.6187 5.5133 14.7213L8.0999 18.3137V20.625C8.0999 21.1223 8.31325 21.5992 8.69301 21.9508C9.07277 22.3025 9.58784 22.5 10.1249 22.5H16.8749C17.412 22.5 17.927 22.3025 18.3068 21.9508C18.6866 21.5992 18.8999 21.1223 18.8999 20.625V18.3137L21.4865 14.7213C21.5603 14.6187 21.5998 14.4982 21.5999 14.375V5.625C21.5999 5.12772 21.3866 4.65081 21.0068 4.29917C20.627 3.94754 20.112 3.75 19.5749 3.75H10.7999V1.875ZM7.4249 5H19.5749C19.7539 5 19.9256 5.06585 20.0522 5.18306C20.1788 5.30027 20.2499 5.45924 20.2499 5.625V14.1862L17.6633 17.7787C17.5895 17.8813 17.55 18.0018 17.5499 18.125V20.625C17.5499 20.7908 17.4788 20.9497 17.3522 21.0669C17.2256 21.1842 17.0539 21.25 16.8749 21.25H10.1249C9.94588 21.25 9.77419 21.1842 9.64761 21.0669C9.52102 20.9497 9.4499 20.7908 9.4499 20.625V18.125C9.4498 18.0018 9.41035 17.8813 9.3365 17.7787L6.7499 14.1862V5.625C6.7499 5.45924 6.82102 5.30027 6.94761 5.18306C7.07419 5.06585 7.24588 5 7.4249 5Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    8: {
      title: "Sun tent",
      name: "sun_tent",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.25 6.5C16.25 6.25 15.25 6.25 14.25 6.25L18.25 2.875L20 7.875C19.125 7.25 18.25 6.875 17.25 6.5ZM8.75 8.875C9.5 8.125 10.375 7.5 11.25 7.125L6.125 6.125L7 11.25C7.5 10.375 8 9.5 8.75 8.875ZM6.5 17.25C6.25 16.25 6.25 15.25 6.25 14.25L2.875 18.25L7.875 20C7.25 19.25 6.75 18.25 6.5 17.25ZM27.5 23.75V26.25H3.75L10.5 19.375C8.125 16.875 8.125 13 10.5 10.5C12.875 8.125 16.875 8.125 19.25 10.5L23 6.75L24.75 8.5L9.625 23.75H27.5ZM12.25 17.625L17.5 12.25C16 10.875 13.75 10.875 12.25 12.25C10.875 13.75 10.875 16.125 12.25 17.625Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    9: {
      title: "Navigation system",
      name: "navigation_system",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.7118 3.57504L3.78756 9.37387L8.21414 11.2127C9.50804 11.7494 10.536 12.7777 11.0723 14.0718L12.9111 18.4975L18.7118 3.57504ZM20.4049 4.20021L14.6042 19.1245C14.2376 20.0686 13.1825 20.5517 12.2475 20.2061C12.0196 20.122 11.8117 19.9917 11.6366 19.8234C11.4615 19.6551 11.323 19.4524 11.23 19.228L9.39023 14.8005C9.03233 13.9383 8.34694 13.2532 7.48448 12.8957L3.05881 11.0569C2.13848 10.6746 1.71864 9.61221 2.12106 8.68271C2.21992 8.4555 2.36274 8.25009 2.5413 8.0783C2.71986 7.90651 2.93063 7.77173 3.16148 7.68171L18.0857 1.88104C18.4099 1.75074 18.7653 1.71858 19.1076 1.78856C19.45 1.85854 19.7642 2.02757 20.0113 2.27465C20.2584 2.52172 20.4274 2.83595 20.4974 3.17829C20.5674 3.52064 20.5352 3.87599 20.4049 4.20021Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    10: {
      title: "Deck shower",
      name: "deck_shower",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="28"
          height="32"
          viewBox="0 0 28 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.1688 18.3639L11.8645 19.8546L13.166 22.8296L14.4466 21.2848L13.1688 18.3639V18.3639ZM13.9988 24.7331L15.2183 27.5206L16.4989 25.9756L15.2794 23.1882L13.9988 24.7331V24.7331ZM24.0038 12.6636L22.7391 14.1893L25.1684 15.5172L26.4332 13.9914L24.0038 12.6636V12.6636ZM18.7361 12.0013L21.0801 13.2825L22.3448 11.7568L20.0484 10.5016L18.7361 12.0013ZM16.832 21.3152L18.3918 23.6921L19.6127 22.2193L18.0529 19.8424L16.832 21.3152ZM16.9877 18.2193L15.4053 15.8079L14.1553 17.2365L15.7668 19.6921L16.9877 18.2193V18.2193ZM16.4469 14.6176L18.453 16.4518L19.6608 14.9947L17.692 13.1946L16.4469 14.6176ZM19.8243 17.7055L21.8325 19.5416L23.0402 18.0845L21.032 16.2485L19.8243 17.7055V17.7055ZM19.0688 6.29276L17.6338 7.9327L16.2821 6.38782C15.7153 5.74008 15.0424 5.22627 14.3019 4.87571C13.5614 4.52515 12.7677 4.34473 11.9661 4.34473C11.1646 4.34473 10.3709 4.52515 9.63039 4.87571C8.88987 5.22627 8.21701 5.74008 7.65023 6.38782C7.63153 6.40914 7.61343 6.43088 7.59505 6.45245C6.95647 5.9383 6.20658 5.6345 5.42722 5.57421C4.64786 5.51391 3.86898 5.69943 3.17559 6.11052C2.4822 6.52161 1.90093 7.14248 1.49523 7.90537C1.08953 8.66825 0.874981 9.54384 0.875 10.4366V25.4998H2.625V10.4366C2.62499 9.91282 2.75024 9.39902 2.9872 8.95072C3.22417 8.50242 3.56384 8.13666 3.96951 7.89299C4.37517 7.64931 4.8314 7.53699 5.28887 7.56816C5.74635 7.59932 6.18766 7.77279 6.56513 8.06982C5.95969 9.38802 5.73845 10.8927 5.93364 12.3647C6.12882 13.8366 6.73024 15.1989 7.65023 16.2529L9.00195 17.7977L7.69382 19.2928L8.78757 20.5428L20.1626 7.54276L19.0688 6.29276ZM10.1175 16.2443L8.88765 14.8387C8.0791 13.9037 7.62716 12.6411 7.63053 11.3265C7.6339 10.012 8.09231 8.75236 8.90563 7.82281C9.71896 6.89327 10.8211 6.36932 11.9713 6.36543C13.1216 6.36153 14.2264 6.87799 15.0445 7.80201L16.2744 9.20763L10.1175 16.2443Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    11: {
      title: "Weather system",
      name: "water_system",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="29"
          height="28"
          viewBox="0 0 29 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.5001 4.2002C18.0743 4.2002 20.1014 6.4038 20.3958 9.0638H20.4857C22.7854 9.0638 24.6501 10.7956 24.6501 12.932C24.6501 15.0684 22.7854 16.8002 20.4857 16.8002L19.4663 16.7988V16.8002H19.4228L18.0352 19.2376C17.9407 19.3969 17.7852 19.5139 17.6021 19.5635C17.4191 19.6131 17.2232 19.5913 17.0566 19.5029C16.8901 19.4144 16.7662 19.2663 16.7116 19.0904C16.6571 18.9146 16.6763 18.7251 16.765 18.5628L17.7698 16.7988H15.1337V16.8002H15.0743L13.6852 19.2376C13.5907 19.3969 13.4352 19.5139 13.2521 19.5635C13.0691 19.6131 12.8732 19.5913 12.7066 19.5029C12.5401 19.4144 12.4162 19.2663 12.3616 19.0904C12.3071 18.9146 12.3263 18.7251 12.415 18.5628L13.4198 16.7988H10.7765V16.8002H10.7243L9.3352 19.2376C9.24068 19.3969 9.08516 19.5139 8.90213 19.5635C8.7191 19.6131 8.52321 19.5913 8.35665 19.5029C8.19009 19.4144 8.06619 19.2663 8.01164 19.0904C7.95709 18.9146 7.97625 18.7251 8.065 18.5628L9.06985 16.7988L8.5145 16.8002C6.2148 16.8002 4.3501 15.0684 4.3501 12.932C4.3501 10.874 6.0785 9.1926 8.26075 9.0708L8.6044 9.0638C8.90165 6.3856 10.9258 4.2002 14.5001 4.2002ZM10.3096 15.4002H20.5625C22.0212 15.4002 23.2001 14.3096 23.2001 12.9642C23.2001 11.6202 22.0198 10.5296 20.564 10.5296H19.7665C19.346 10.5296 18.9762 10.2244 18.9762 9.8352C18.9762 7.3474 16.8926 5.6002 14.5001 5.6002C12.1076 5.6002 10.0239 7.3782 10.0239 9.8352C10.0239 10.2244 9.65565 10.5296 9.2337 10.5296H8.4362C6.9804 10.5296 5.8001 11.6202 5.8001 12.9656C5.8001 14.3082 6.9804 15.4002 8.4362 15.4002H10.282C10.2917 15.4 10.3014 15.4 10.311 15.4002H10.3096ZM11.2347 20.0426C11.4016 20.1347 11.5237 20.287 11.5743 20.4661C11.6248 20.6451 11.5997 20.8362 11.5044 20.9974L10.0544 23.4474C9.95661 23.6039 9.7993 23.7173 9.61608 23.7633C9.43286 23.8093 9.23828 23.7843 9.07391 23.6936C8.90954 23.6029 8.78843 23.4537 8.73646 23.278C8.68449 23.1022 8.70579 22.9138 8.7958 22.753L10.2458 20.303C10.3412 20.1419 10.499 20.024 10.6844 19.9751C10.8699 19.9263 11.0678 19.9506 11.2347 20.0426ZM15.8544 20.9974C15.9444 20.8366 15.9657 20.6482 15.9137 20.4724C15.8618 20.2967 15.7407 20.1475 15.5763 20.0568C15.4119 19.9661 15.2173 19.9411 15.0341 19.9871C14.8509 20.0331 14.6936 20.1465 14.5958 20.303L13.1458 22.753C13.0558 22.9138 13.0345 23.1022 13.0865 23.278C13.1384 23.4537 13.2595 23.6029 13.4239 23.6936C13.5883 23.7843 13.7829 23.8093 13.9661 23.7633C14.1493 23.7173 14.3066 23.6039 14.4044 23.4474L15.8544 20.9974Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    12: {
      title: "Pets Allowed ",
      name: "pets_allowed ",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.5 12C5.88071 12 7 10.8807 7 9.5C7 8.11929 5.88071 7 4.5 7C3.11929 7 2 8.11929 2 9.5C2 10.8807 3.11929 12 4.5 12Z"
            fill="black"
          />
          <path
            d="M9 8C10.3807 8 11.5 6.88071 11.5 5.5C11.5 4.11929 10.3807 3 9 3C7.61929 3 6.5 4.11929 6.5 5.5C6.5 6.88071 7.61929 8 9 8Z"
            fill="black"
          />
          <path
            d="M15 8C16.3807 8 17.5 6.88071 17.5 5.5C17.5 4.11929 16.3807 3 15 3C13.6193 3 12.5 4.11929 12.5 5.5C12.5 6.88071 13.6193 8 15 8Z"
            fill="black"
          />
          <path
            d="M19.5 12C20.8807 12 22 10.8807 22 9.5C22 8.11929 20.8807 7 19.5 7C18.1193 7 17 8.11929 17 9.5C17 10.8807 18.1193 12 19.5 12Z"
            fill="black"
          />
          <path
            d="M17.3401 14.86C16.4701 13.84 15.7401 12.97 14.8601 11.95C14.4001 11.41 13.8101 10.87 13.1101 10.63C13.0001 10.59 12.8901 10.56 12.7801 10.54C12.5301 10.5 12.2601 10.5 12.0001 10.5C11.7401 10.5 11.4701 10.5 11.2101 10.55C11.1001 10.57 10.9901 10.6 10.8801 10.64C10.1801 10.88 9.60014 11.42 9.13014 11.96C8.26014 12.98 7.53014 13.85 6.65014 14.87C5.34014 16.18 3.73014 17.63 4.03014 19.66C4.32014 20.68 5.05014 21.69 6.36014 21.98C7.09014 22.13 9.42014 21.54 11.9001 21.54H12.0801C14.5601 21.54 16.8901 22.12 17.6201 21.98C18.9301 21.69 19.6601 20.67 19.9501 19.66C20.2601 17.62 18.6501 16.17 17.3401 14.86V14.86Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    13: {
      title: "Fully equipped kitchen",
      name: "equipped_itchen",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="30"
          height="28"
          viewBox="0 0 30 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.5 2.34516L7.5 2.3335C6.83696 2.3335 6.20107 2.57933 5.73223 3.01691C5.26339 3.4545 5 4.04799 5 4.66683V23.3335C5 24.6168 6.125 25.6668 7.5 25.6668H22.5C23.875 25.6668 25 24.6168 25 23.3335V4.66683C25 3.37183 23.875 2.34516 22.5 2.34516ZM22.5 23.3335H7.5V12.8102H22.5V23.3335ZM22.5 10.5002H7.5V4.66683H22.5V10.5002ZM10 5.8335H12.5V9.3335H10V5.8335ZM10 14.0002H12.5V19.8335H10V14.0002Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    14: {
      title: "Music system",
      name: "music_system",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.0001 9.85L19.1401 7H18.6401V10.79L16.3501 8.5L15.6401 9.21L18.4301 12L15.6401 14.79L16.3501 15.5L18.6401 13.21V17H19.1401L22.0001 14.15L19.8501 12L22.0001 9.85ZM19.6401 8.91L20.5801 9.85L19.6401 10.79V8.91ZM20.5801 14.15L19.6401 15.09V13.21L20.5801 14.15ZM9.64014 3V13.55C9.05014 13.21 8.37014 13 7.64014 13C5.43014 13 3.64014 14.79 3.64014 17C3.64014 19.21 5.43014 21 7.64014 21C9.85014 21 11.6401 19.21 11.6401 17V7H15.6401V3H9.64014Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    15: {
      title: "BBQ",
      name: "bbq",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="28"
          height="31"
          viewBox="0 0 28 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.232422 14.9346C0.601112 16.7879 1.46403 18.5076 2.72989 19.9108C4.87782 22.2465 8.15162 23.545 12.4434 23.796V22.8169C12.4434 21.9577 13.1398 21.2612 13.9991 21.2612C14.8584 21.2612 15.5548 21.9577 15.5548 22.8169V23.8048C17.4383 23.7234 19.2974 23.3495 21.0657 22.6972C21.6657 22.469 22.2465 22.1936 22.8029 21.8731C22.8206 21.8591 22.8392 21.8467 22.8585 21.8353C25.4124 20.3495 27.2015 17.835 27.7683 14.9351C25.2781 16.8881 19.51 17.9226 14.0006 17.9226C8.49076 17.9221 2.72214 16.8875 0.232422 14.9346Z"
            fill="#1A4D6D"
          />
          <path
            d="M28 12.7566C27.9948 10.8051 22.2469 8.63184 14 8.63184C5.74947 8.63184 0 10.8067 0 12.7592C0 14.7117 5.74947 16.8866 14 16.8866C22.193 16.8866 27.917 14.7418 27.9964 12.8002L27.9958 12.7837C27.9959 12.7742 28 12.7659 28 12.7566ZM2.59029 14.0027C2.3808 14.0027 2.19152 13.8762 2.1111 13.6827C2.03073 13.4888 2.07532 13.2658 2.22365 13.1174L4.81653 10.5246C5.01926 10.3254 5.34548 10.3265 5.54668 10.5277C5.74789 10.7289 5.74947 11.0546 5.5498 11.2578L2.95692 13.8507C2.8594 13.9482 2.7277 14.0027 2.59029 14.0027ZM4.66455 15.0399C4.45506 15.0399 4.26578 14.9133 4.18536 14.7199C4.105 14.5259 4.14958 14.303 4.29792 14.1547L8.4465 10.0061C8.64929 9.80693 8.97545 9.80799 9.17666 10.0092C9.37786 10.2104 9.37945 10.5361 9.17977 10.7393L5.03119 14.8879C4.93373 14.9854 4.80202 15.0399 4.66455 15.0399ZM7.25748 15.5585C7.048 15.5585 6.85872 15.4319 6.77829 15.2385C6.69793 15.0446 6.74252 14.8216 6.89085 14.6732L12.0766 9.48747C12.2794 9.28832 12.6055 9.28938 12.8068 9.49059C13.008 9.69179 13.0095 10.0175 12.8099 10.2207L7.62412 15.4065C7.5266 15.504 7.39489 15.5585 7.25748 15.5585ZM9.85036 16.077C9.64087 16.077 9.45159 15.9505 9.37117 15.757C9.2908 15.5631 9.33539 15.3401 9.48372 15.1918L15.1881 9.48741C15.3188 9.35465 15.5107 9.30178 15.6906 9.34948C15.8705 9.39718 16.0116 9.5377 16.0593 9.71817C16.107 9.89811 16.0541 10.09 15.9213 10.2207L10.217 15.925C10.1195 16.0226 9.98776 16.077 9.85036 16.077ZM13.3284 15.9251C13.1256 16.1242 12.7995 16.1232 12.5983 15.922C12.3971 15.7208 12.3955 15.3951 12.5951 15.1918L17.7809 10.0061C17.9115 9.87332 18.1035 9.82044 18.2834 9.86815C18.4633 9.91585 18.6044 10.0564 18.6521 10.2368C18.6998 10.4168 18.6469 10.6086 18.5142 10.7393L13.3284 15.9251ZM16.0733 16.077C15.8638 16.077 15.6745 15.9505 15.5941 15.757C15.5137 15.5631 15.5583 15.3401 15.7066 15.1918L20.3738 10.5246C20.5045 10.3918 20.6964 10.3389 20.8763 10.3866C21.0563 10.4343 21.1973 10.5749 21.245 10.7553C21.2927 10.9353 21.2399 11.1271 21.1071 11.2578L16.4399 15.925C16.3424 16.0226 16.2107 16.077 16.0733 16.077ZM19.7033 15.5585C19.4938 15.5585 19.3045 15.4319 19.2242 15.2385C19.1438 15.0446 19.1884 14.8216 19.3367 14.6732L23.4853 10.5246C23.616 10.3918 23.8079 10.3389 23.9878 10.3866C24.1678 10.4343 24.3088 10.5749 24.3565 10.7553C24.4042 10.9353 24.3513 11.1271 24.2186 11.2578L20.07 15.4064C19.9724 15.504 19.8407 15.5585 19.7033 15.5585ZM25.7743 12.8136L23.7 14.8879C23.4972 15.0871 23.171 15.086 22.9698 14.8848C22.7686 14.6836 22.7671 14.3579 22.9667 14.1547L25.041 12.0803C25.1717 11.9476 25.3636 11.8947 25.5435 11.9424C25.7235 11.9901 25.8645 12.1306 25.9122 12.3111C25.9599 12.491 25.9071 12.683 25.7743 12.8136Z"
            fill="#1A4D6D"
          />
          <path
            d="M23.526 22.6436C23.497 22.6612 23.4705 22.6793 23.441 22.697C23.4223 22.712 23.4026 22.7254 23.3824 22.7374C23.1335 22.8821 22.8773 23.0128 22.6201 23.1409L25.1051 27.8983C25.1663 28.0238 25.2768 28.1182 25.4106 28.1592C25.5443 28.2001 25.6885 28.1841 25.8099 28.1151C26.0598 27.9808 26.1547 27.6696 26.0215 27.4187L23.526 22.6436Z"
            fill="#1A4D6D"
          />
          <path
            d="M1.97653 27.3981C1.91121 27.5204 1.89823 27.6641 1.94023 27.7963C1.98223 27.9285 2.07611 28.038 2.20006 28.1002C2.45261 28.2288 2.7622 28.1297 2.89238 27.8777L5.36653 23.1416C5.0533 22.9849 4.75046 22.818 4.4585 22.6406L1.97653 27.3981Z"
            fill="#1A4D6D"
          />
          <path
            d="M13.999 22.2988C13.7128 22.2994 13.4809 22.5312 13.4805 22.8174V29.5589C13.4805 29.8452 13.7128 30.0774 13.999 30.0774C14.2853 30.0774 14.5176 29.8451 14.5176 29.5589V22.8174C14.5171 22.5312 14.2853 22.2988 13.999 22.2988Z"
            fill="#1A4D6D"
          />
          <path
            d="M10.3315 5.64176L10.1236 5.89014C9.93999 6.11002 9.96901 6.43724 10.1884 6.62082C10.2859 6.70171 10.4036 6.74166 10.5213 6.74166C10.6696 6.74166 10.8169 6.67839 10.9185 6.55702L11.127 6.30811C11.7685 5.54113 11.7685 4.42724 11.126 3.65873C10.8065 3.27705 10.8065 2.72267 11.126 2.34105L12.3711 0.852194C12.5552 0.632307 12.5261 0.305092 12.3063 0.12151C12.0869 -0.0631284 11.7592 -0.0340491 11.5756 0.186307L10.3305 1.67517C9.68849 2.44268 9.68849 3.55657 10.3315 4.32455C10.6504 4.70629 10.6504 5.26061 10.3315 5.64176Z"
            fill="#1A4D6D"
          />
          <path
            d="M13.4429 5.64126L13.2349 5.88964C13.0513 6.10952 13.0803 6.43674 13.2997 6.62032C13.3972 6.70121 13.5149 6.74116 13.6326 6.74116C13.7809 6.74116 13.9282 6.67789 14.0298 6.55652L14.2383 6.30761C14.8803 5.54063 14.8803 4.42674 14.2373 3.65823C13.9178 3.27655 13.9178 2.72217 14.2373 2.34055L15.4824 0.851694C15.6655 0.631808 15.637 0.304593 15.4171 0.121011C15.1962 -0.0636275 14.87 -0.0330208 14.6864 0.185808L13.4418 1.67467C12.7998 2.44218 12.7998 3.55607 13.4429 4.32405C13.7618 4.70579 13.7618 5.26011 13.4429 5.64126Z"
            fill="#1A4D6D"
          />
          <path
            d="M16.5552 5.64126L16.3472 5.88964C16.1636 6.10952 16.1922 6.43674 16.412 6.62032C16.509 6.70121 16.6272 6.74116 16.7444 6.74116C16.8927 6.74116 17.04 6.67789 17.1422 6.55652L17.3501 6.30761C17.9921 5.54063 17.9921 4.42674 17.3491 3.65823C17.0301 3.27655 17.0301 2.72217 17.3496 2.34055L18.5942 0.851694C18.7772 0.631808 18.7487 0.304593 18.5289 0.121011C18.308 -0.0636275 17.9818 -0.0330208 17.7982 0.185808L16.5541 1.67467C15.9121 2.44218 15.9121 3.55607 16.5552 4.32405C16.8741 4.70579 16.8741 5.25959 16.5552 5.64126Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    16: {
      title: "Washing machine",
      name: "wahing_machine",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 5.01L18.01 4.999M21 4V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V4C3 3.46957 3.21071 2.96086 3.58579 2.58579C3.96086 2.21071 4.46957 2 5 2H19C19.5304 2 20.0391 2.21071 20.4142 2.58579C20.7893 2.96086 21 3.46957 21 4Z"
            stroke="#1A4D6D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 19C13.5913 19 15.1174 18.3679 16.2426 17.2426C17.3679 16.1174 18 14.5913 18 13C18 11.4087 17.3679 9.88258 16.2426 8.75736C15.1174 7.63214 13.5913 7 12 7C10.4087 7 8.88258 7.63214 7.75736 8.75736C6.63214 9.88258 6 11.4087 6 13C6 14.5913 6.63214 16.1174 7.75736 17.2426C8.88258 18.3679 10.4087 19 12 19V19Z"
            stroke="#1A4D6D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 16C11.2044 16 10.4413 15.6839 9.87868 15.1213C9.31607 14.5587 9 13.7956 9 13"
            stroke="#1A4D6D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
    },
    17: {
      title: "Safety Systems ( vests , flare gun, fire systems) ",
      name: "safety_system",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="31"
          height="30"
          viewBox="0 0 31 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.3958 18.875H15.2708V15.75H18.5V12H15.2708V8.875H11.3958V12H8.16667V15.75H11.3958V18.875ZM13.3333 27C10.341 26.2708 7.87088 24.6092 5.92304 22.015C3.97435 19.4217 3 16.5417 3 13.375V5.75L13.3333 2L23.6667 5.75V13.375C23.6667 16.5417 22.6928 19.4217 20.7449 22.015C18.7962 24.6092 16.3257 26.2708 13.3333 27ZM13.3333 24.375C15.5722 23.6875 17.4236 22.3125 18.8875 20.25C20.3514 18.1875 21.0833 15.8958 21.0833 13.375V7.46875L13.3333 4.65625L5.58333 7.46875V13.375C5.58333 15.8958 6.31528 18.1875 7.77917 20.25C9.24306 22.3125 11.0944 23.6875 13.3333 24.375Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    18: {
      title: "Dryer",
      name: "dryer",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 22H20C20.2652 22 20.5196 21.8946 20.7071 21.7071C20.8946 21.5196 21 21.2652 21 21V5C21 3.346 19.654 2 18 2H6C4.346 2 3 3.346 3 5V21C3 21.2652 3.10536 21.5196 3.29289 21.7071C3.48043 21.8946 3.73478 22 4 22ZM18 3.924C18.1313 3.924 18.2614 3.94987 18.3827 4.00012C18.504 4.05038 18.6142 4.12403 18.7071 4.21689C18.8 4.30975 18.8736 4.41999 18.9239 4.54132C18.9741 4.66264 19 4.79268 19 4.924C19 5.05532 18.9741 5.18536 18.9239 5.30668C18.8736 5.42801 18.8 5.53825 18.7071 5.63111C18.6142 5.72397 18.504 5.79762 18.3827 5.84788C18.2614 5.89813 18.1313 5.924 18 5.924C17.7348 5.924 17.4804 5.81864 17.2929 5.63111C17.1054 5.44357 17 5.18922 17 4.924C17 4.65878 17.1054 4.40443 17.2929 4.21689C17.4804 4.02936 17.7348 3.924 18 3.924ZM15 3.924C15.1313 3.924 15.2614 3.94987 15.3827 4.00012C15.504 4.05038 15.6142 4.12403 15.7071 4.21689C15.8 4.30975 15.8736 4.41999 15.9239 4.54132C15.9741 4.66264 16 4.79268 16 4.924C16 5.05532 15.9741 5.18536 15.9239 5.30668C15.8736 5.42801 15.8 5.53825 15.7071 5.63111C15.6142 5.72397 15.504 5.79762 15.3827 5.84788C15.2614 5.89813 15.1313 5.924 15 5.924C14.7348 5.924 14.4804 5.81864 14.2929 5.63111C14.1054 5.44357 14 5.18922 14 4.924C14 4.65878 14.1054 4.40443 14.2929 4.21689C14.4804 4.02936 14.7348 3.924 15 3.924V3.924ZM12 7.041C15.309 7.041 18 9.732 18 13.041C18 16.35 15.309 19.041 12 19.041C8.691 19.041 6 16.35 6 13.041C6 9.732 8.691 7.041 12 7.041Z"
            fill="#1A4D6D"
          />
          <path
            d="M9.31981 12.265C8.90481 12.649 8.27881 13.229 8.27881 14.332C8.27881 15.436 8.90481 16.016 9.31981 16.4C9.67181 16.725 9.71981 16.798 9.71981 17H11.7198C11.7198 15.896 11.0938 15.316 10.6788 14.932C10.3268 14.607 10.2788 14.534 10.2788 14.332C10.2788 14.13 10.3268 14.057 10.6788 13.732C11.0928 13.348 11.7198 12.768 11.7198 11.664C11.7198 10.561 11.0938 9.981 10.6788 9.598C10.3278 9.273 10.2798 9.201 10.2798 9H8.27981C8.27981 10.104 8.90681 10.683 9.32181 11.066C9.67281 11.39 9.72081 11.462 9.72081 11.663C9.71981 11.866 9.67081 11.939 9.31981 12.265V12.265ZM13.3198 12.265C12.9058 12.649 12.2798 13.229 12.2798 14.332C12.2798 15.435 12.9058 16.016 13.3198 16.399C13.6708 16.724 13.7188 16.797 13.7188 17H15.7188C15.7188 15.896 15.0928 15.316 14.6788 14.933C14.3278 14.608 14.2798 14.535 14.2798 14.332C14.2798 14.129 14.3288 14.057 14.6788 13.731C15.0928 13.347 15.7188 12.767 15.7188 11.663C15.7188 10.56 15.0928 9.981 14.6788 9.598C14.3288 9.274 14.2798 9.201 14.2798 9H12.2798C12.2798 10.103 12.9058 10.683 13.3208 11.066C13.6708 11.39 13.7188 11.463 13.7188 11.664C13.7198 11.866 13.6708 11.939 13.3198 12.265V12.265Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    19: {
      title: "Gaming console",
      name: "gaming_console",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="24"
          height="26"
          viewBox="0 0 24 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.9601 19.9334C20.0001 20.4534 18.7201 20.1067 18.0801 19.0667L16.3201 16.6401H7.68006L5.92006 19.0667C5.12006 20.2801 3.68006 20.4534 2.56006 19.5867C1.76006 18.8934 1.44006 17.8534 1.60006 16.9867L2.72006 10.5734C3.04006 8.4934 4.80006 6.9334 6.72006 6.9334H11.2001V4.3334C11.2001 2.94673 12.1601 1.7334 13.4401 1.7334H18.4001C18.8801 1.7334 19.2001 2.08007 19.2001 2.60007C19.2001 3.12007 18.8801 3.46673 18.4001 3.46673H13.6001C13.1201 3.46673 12.8001 3.8134 12.8001 4.16007V6.9334H17.2801C19.2001 6.9334 20.9601 8.4934 21.2801 10.5734L22.4001 16.9867C22.5601 18.2001 22.0801 19.4134 20.9601 19.9334ZM9.60006 11.2667C9.60006 9.88006 8.48006 8.66673 7.20006 8.66673C5.92006 8.66673 4.80006 9.88006 4.80006 11.2667C4.80006 12.6534 5.92006 13.8667 7.20006 13.8667C8.48006 13.8667 9.60006 12.6534 9.60006 11.2667ZM19.2001 11.2667C19.2001 10.7467 18.8801 10.4001 18.4001 10.4001H17.6001V9.5334C17.6001 9.0134 17.2801 8.66673 16.8001 8.66673C16.3201 8.66673 16.0001 9.0134 16.0001 9.5334V10.4001H15.2001C14.7201 10.4001 14.4001 10.7467 14.4001 11.2667C14.4001 11.7867 14.7201 12.1334 15.2001 12.1334H16.0001V13.0001C16.0001 13.5201 16.3201 13.8667 16.8001 13.8667C17.2801 13.8667 17.6001 13.5201 17.6001 13.0001V12.1334H18.4001C18.8801 12.1334 19.2001 11.7867 19.2001 11.2667Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    20: {
      title: "Crew",
      name: "crew",
      input: false,
      input_value: "",
      suggest_feature: false,
      img: crew_icon,
    },
    21: {
      title: "Captain",
      name: "captain",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="23"
          height="21"
          viewBox="0 0 23 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M23 9.78375C23 7.40645 21.7469 4.9484 19.5619 3.03986C17.3176 1.07958 14.4545 0 11.5 0C8.54551 0 5.68243 1.07958 3.43815 3.03986C1.25318 4.9484 0 7.40645 0 9.78375V10.1058L1.30679 11.5539H21.7775L23 10.0989V9.78375ZM11.542 9.80619C10.071 9.80619 8.87426 8.42451 8.87426 6.72626H10.2212C10.2212 7.28324 10.4813 7.77117 10.8685 8.0373V5.39144H9.93976V3.83637H10.8685V2.5652H12.2155V3.83637H13.1443V5.39144H12.2155V8.0373C12.6028 7.77117 12.8629 7.28319 12.8629 6.72626H14.2098C14.2098 8.42451 13.0131 9.80619 11.542 9.80619Z"
            fill="#1A4D6D"
          />
          <path
            d="M2.20654 13.1094H20.8592V14.7451H2.20654V13.1094Z"
            fill="#1A4D6D"
          />
          <path
            d="M2.20654 16.2998V16.3363L2.22441 17.2721C2.22441 19.3278 3.67182 21.0002 5.45095 21.0002H17.6327C19.4118 21.0002 20.8592 19.3277 20.8592 17.2721V16.2998H2.20654Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    22: {
      title: "Suggest Feature",
      name: "suggest_feature",
      input: false,
      suggest_feature: true,
      icon: null,
      input_value: "",
    },
  };

  //=============== luxury_featuresList =======================================
  const luxury_dataList = {
    0: {
      title: "Outdoor pool",
      name: "outdoor_pool",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 15H18V16.47C18.5807 16.7548 19.1083 17.137 19.56 17.6C19.6998 17.4593 19.8466 17.3258 20 17.2V3C20 2.73478 20.1054 2.48043 20.2929 2.29289C20.4804 2.10536 20.7348 2 21 2C21.2652 2 21.5196 2.10536 21.7071 2.29289C21.8946 2.48043 22 2.73478 22 3C22 3.26522 22.1054 3.51957 22.2929 3.70711C22.4804 3.89464 22.7348 4 23 4C23.2652 4 23.5196 3.89464 23.7071 3.70711C23.8946 3.51957 24 3.26522 24 3C24 2.20435 23.6839 1.44129 23.1213 0.87868C22.5587 0.316071 21.7956 0 21 0C20.2044 0 19.4413 0.316071 18.8787 0.87868C18.3161 1.44129 18 2.20435 18 3V7H11V3C11 2.73478 11.1054 2.48043 11.2929 2.29289C11.4804 2.10536 11.7348 2 12 2C12.2652 2 12.5196 2.10536 12.7071 2.29289C12.8946 2.48043 13 2.73478 13 3C13 3.26522 13.1054 3.51957 13.2929 3.70711C13.4804 3.89464 13.7348 4 14 4C14.2652 4 14.5196 3.89464 14.7071 3.70711C14.8946 3.51957 15 3.26522 15 3C15 2.20435 14.6839 1.44129 14.1213 0.87868C13.5587 0.316071 12.7956 0 12 0C11.2044 0 10.4413 0.316071 9.87868 0.87868C9.31607 1.44129 9 2.20435 9 3V16.03C9.70763 16.1044 10.3903 16.3331 11 16.7V15ZM18 9V13H11V9H18Z"
            fill="#1A4D6D"
          />
          <path
            d="M27 20C26.771 19.9866 26.5486 19.9176 26.3523 19.7989C26.1559 19.6803 25.9914 19.5155 25.873 19.319C25.5755 18.9104 25.1857 18.5778 24.7352 18.3486C24.2847 18.1193 23.7864 17.9998 23.281 17.9998C22.7756 17.9998 22.2773 18.1193 21.8268 18.3486C21.3763 18.5778 20.9865 18.9104 20.689 19.319C20.5815 19.5246 20.4198 19.6968 20.2214 19.817C20.023 19.9371 19.7955 20.0007 19.5635 20.0007C19.3315 20.0007 19.104 19.9371 18.9056 19.817C18.7072 19.6968 18.5455 19.5246 18.438 19.319C18.1412 18.9102 17.7518 18.5775 17.3018 18.3481C16.8517 18.1186 16.3537 17.999 15.8485 17.999C15.3433 17.999 14.8453 18.1186 14.3952 18.3481C13.9452 18.5775 13.5558 18.9102 13.259 19.319C13.1419 19.5156 12.9783 19.6804 12.7827 19.7991C12.5871 19.9178 12.3654 19.9868 12.137 20C11.9088 19.9864 11.6873 19.9174 11.4918 19.7989C11.2963 19.6804 11.1326 19.516 11.015 19.32C10.712 18.9176 10.3213 18.5895 9.87251 18.3608C9.42371 18.132 8.92865 18.0086 8.425 18C7.9216 18.0087 7.4268 18.132 6.97818 18.3605C6.52957 18.5891 6.13895 18.9169 5.836 19.319C5.71878 19.5157 5.5551 19.6806 5.35931 19.7994C5.16352 19.9181 4.9416 19.987 4.713 20C4.4844 19.987 4.26248 19.9181 4.06669 19.7994C3.8709 19.6806 3.70722 19.5157 3.59 19.319C3.28679 18.9169 2.89598 18.5892 2.44721 18.3606C1.99845 18.1321 1.50353 18.0087 1 18C0.734784 18 0.48043 18.1054 0.292893 18.2929C0.105357 18.4804 0 18.7348 0 19V28H28V21C28 20.7348 27.8946 20.4804 27.7071 20.2929C27.5196 20.1054 27.2652 20 27 20Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    1: {
      title: "Sauna ( steam room)",
      name: "steam_room",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="29"
          height="30"
          viewBox="0 0 29 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.8958 1.25C13.4151 1.25 12.9541 1.44754 12.6142 1.79917C12.2743 2.15081 12.0833 2.62772 12.0833 3.125V18.125C11.3221 18.7125 10.875 19.6375 10.875 20.625C10.875 21.4538 11.1933 22.2487 11.7598 22.8347C12.3263 23.4208 13.0947 23.75 13.8958 23.75C14.697 23.75 15.4654 23.4208 16.0319 22.8347C16.5984 22.2487 16.9167 21.4538 16.9167 20.625C16.9167 19.6375 16.4696 18.75 15.7083 18.125V16.25H20.5417V13.75H15.7083V11.25H20.5417V8.75H15.7083V6.25H20.5417V3.75H15.7083V3.125C15.7083 2.62772 15.5174 2.15081 15.1775 1.79917C14.8376 1.44754 14.3765 1.25 13.8958 1.25ZM0 18.75V21.25C0.809583 21.25 0.954583 21.5125 1.55875 22.1375C2.16292 22.7625 3.22625 23.75 4.83333 23.75C6.44042 23.75 7.50375 22.7625 8.10792 22.1375C8.24083 21.9875 8.34958 21.875 8.45833 21.7625V18.95C7.50375 19.275 6.82708 19.9125 6.39208 20.3625C5.78792 20.9875 5.64292 21.25 4.83333 21.25C4.02375 21.25 3.87875 20.9875 3.27458 20.3625C2.67042 19.7375 1.60708 18.75 0 18.75ZM19.3333 18.75V21.25C20.1429 21.25 20.2879 21.5125 20.8921 22.1375C21.4963 22.7625 22.5596 23.75 24.1667 23.75C25.7738 23.75 26.8371 22.7625 27.4412 22.1375C28.0454 21.5125 28.1904 21.25 29 21.25V18.75C27.3929 18.75 26.3296 19.7375 25.7254 20.3625C25.1213 20.9875 24.9763 21.25 24.1667 21.25C23.3571 21.25 23.2121 20.9875 22.6079 20.3625C22.0037 19.7375 20.9404 18.75 19.3333 18.75ZM9.66667 25C8.05958 25 6.99625 25.9875 6.39208 26.6125C5.78792 27.2375 5.64292 27.5 4.83333 27.5C4.02375 27.5 3.87875 27.2375 3.27458 26.6125C2.83958 26.1625 2.16292 25.525 1.20833 25.2V28.0125C1.31708 28.125 1.42583 28.2375 1.55875 28.3875C2.16292 29.0125 3.22625 30 4.83333 30C6.44042 30 7.50375 29.0125 8.10792 28.3875C8.71208 27.7625 8.85708 27.5 9.66667 27.5C10.4763 27.5 10.6213 27.7625 11.2254 28.3875C11.7571 28.925 12.615 29.75 13.8958 29.95C14.0892 30 14.2946 30 14.5 30C16.1071 30 17.1704 29.0125 17.7746 28.3875C18.3787 27.7625 18.5238 27.5 19.3333 27.5C20.1429 27.5 20.2879 27.7625 20.8921 28.3875C21.4963 29.0125 22.5596 30 24.1667 30C25.7738 30 26.8371 29.0125 27.4412 28.3875C27.5742 28.2375 27.6829 28.125 27.7917 28.0125V25.2C26.8371 25.525 26.1604 26.1625 25.7254 26.6125C25.1213 27.2375 24.9763 27.5 24.1667 27.5C23.3571 27.5 23.2121 27.2375 22.6079 26.6125C22.0037 25.9875 20.9404 25 19.3333 25C17.7262 25 16.6629 25.9875 16.0588 26.6125C15.4546 27.2375 15.3096 27.5 14.5 27.5C14.2342 27.5 14.0529 27.4625 13.8958 27.4C13.5575 27.275 13.3521 27.0375 12.9413 26.6125C12.3371 25.9875 11.2738 25 9.66667 25Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    2: {
      title: "Indoor pool",
      name: "indoor_pool",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 15H18V16.47C18.5807 16.7548 19.1083 17.137 19.56 17.6C19.6998 17.4593 19.8466 17.3258 20 17.2V3C20 2.73478 20.1054 2.48043 20.2929 2.29289C20.4804 2.10536 20.7348 2 21 2C21.2652 2 21.5196 2.10536 21.7071 2.29289C21.8946 2.48043 22 2.73478 22 3C22 3.26522 22.1054 3.51957 22.2929 3.70711C22.4804 3.89464 22.7348 4 23 4C23.2652 4 23.5196 3.89464 23.7071 3.70711C23.8946 3.51957 24 3.26522 24 3C24 2.20435 23.6839 1.44129 23.1213 0.87868C22.5587 0.316071 21.7956 0 21 0C20.2044 0 19.4413 0.316071 18.8787 0.87868C18.3161 1.44129 18 2.20435 18 3V7H11V3C11 2.73478 11.1054 2.48043 11.2929 2.29289C11.4804 2.10536 11.7348 2 12 2C12.2652 2 12.5196 2.10536 12.7071 2.29289C12.8946 2.48043 13 2.73478 13 3C13 3.26522 13.1054 3.51957 13.2929 3.70711C13.4804 3.89464 13.7348 4 14 4C14.2652 4 14.5196 3.89464 14.7071 3.70711C14.8946 3.51957 15 3.26522 15 3C15 2.20435 14.6839 1.44129 14.1213 0.87868C13.5587 0.316071 12.7956 0 12 0C11.2044 0 10.4413 0.316071 9.87868 0.87868C9.31607 1.44129 9 2.20435 9 3V16.03C9.70763 16.1044 10.3903 16.3331 11 16.7V15ZM18 9V13H11V9H18Z"
            fill="#1A4D6D"
          />
          <path
            d="M27 20C26.771 19.9866 26.5486 19.9176 26.3523 19.7989C26.1559 19.6803 25.9914 19.5155 25.873 19.319C25.5755 18.9104 25.1857 18.5778 24.7352 18.3486C24.2847 18.1193 23.7864 17.9998 23.281 17.9998C22.7756 17.9998 22.2773 18.1193 21.8268 18.3486C21.3763 18.5778 20.9865 18.9104 20.689 19.319C20.5815 19.5246 20.4198 19.6968 20.2214 19.817C20.023 19.9371 19.7955 20.0007 19.5635 20.0007C19.3315 20.0007 19.104 19.9371 18.9056 19.817C18.7072 19.6968 18.5455 19.5246 18.438 19.319C18.1412 18.9102 17.7518 18.5775 17.3018 18.3481C16.8517 18.1186 16.3537 17.999 15.8485 17.999C15.3433 17.999 14.8453 18.1186 14.3952 18.3481C13.9452 18.5775 13.5558 18.9102 13.259 19.319C13.1419 19.5156 12.9783 19.6804 12.7827 19.7991C12.5871 19.9178 12.3654 19.9868 12.137 20C11.9088 19.9864 11.6873 19.9174 11.4918 19.7989C11.2963 19.6804 11.1326 19.516 11.015 19.32C10.712 18.9176 10.3213 18.5895 9.87251 18.3608C9.42371 18.132 8.92865 18.0086 8.425 18C7.9216 18.0087 7.4268 18.132 6.97818 18.3605C6.52957 18.5891 6.13895 18.9169 5.836 19.319C5.71878 19.5157 5.5551 19.6806 5.35931 19.7994C5.16352 19.9181 4.9416 19.987 4.713 20C4.4844 19.987 4.26248 19.9181 4.06669 19.7994C3.8709 19.6806 3.70722 19.5157 3.59 19.319C3.28679 18.9169 2.89598 18.5892 2.44721 18.3606C1.99845 18.1321 1.50353 18.0087 1 18C0.734784 18 0.48043 18.1054 0.292893 18.2929C0.105357 18.4804 0 18.7348 0 19V28H28V21C28 20.7348 27.8946 20.4804 27.7071 20.2929C27.5196 20.1054 27.2652 20 27 20Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    3: {
      title: "Jacuzzi ( indoor outdoor ) ",
      name: "jacuzzi_indoor_outdoor",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="27"
          height="27"
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1222_2752)">
            <path
              d="M0.060513 5.59255C0.143797 5.38492 0.306131 5.21886 0.511821 5.13089C0.717512 5.04292 0.949719 5.04023 1.15739 5.12343L4.12233 6.30974C4.72572 6.55105 5.39881 6.55105 6.0022 6.30974L7.71333 5.62461C8.71915 5.22228 9.84119 5.22228 10.847 5.62461L12.5598 6.30974C13.1632 6.55105 13.8363 6.55105 14.4397 6.30974L16.1508 5.62461C17.1566 5.22228 18.2787 5.22228 19.2845 5.62461L20.9973 6.30974C21.6007 6.55105 22.2738 6.55105 22.8772 6.30974L25.8421 5.12343C25.9455 5.07949 26.0565 5.05662 26.1688 5.05616C26.2811 5.05569 26.3923 5.07764 26.496 5.12072C26.5997 5.1638 26.6937 5.22714 26.7726 5.30702C26.8515 5.38691 26.9137 5.48174 26.9555 5.58596C26.9972 5.69018 27.0178 5.80168 27.0159 5.91395C27.0141 6.02621 26.9898 6.13697 26.9446 6.23974C26.8994 6.34251 26.8341 6.43522 26.7526 6.51244C26.6711 6.58965 26.575 6.64983 26.4699 6.68943L23.5033 7.87574C22.4974 8.27808 21.3754 8.27808 20.3696 7.87574L18.6585 7.19061C18.0551 6.9493 17.382 6.9493 16.7786 7.19061L15.0658 7.87574C14.0599 8.27808 12.9379 8.27808 11.9321 7.87574L10.221 7.19061C9.61756 6.9493 8.94447 6.9493 8.34108 7.19061L6.62826 7.87574C5.62244 8.27808 4.5004 8.27808 3.49458 7.87574L0.529638 6.68943C0.322005 6.60614 0.155947 6.44381 0.0679747 6.23812C-0.0199975 6.03243 -0.0226814 5.80022 0.060513 5.59255ZM0.060513 10.6551C0.143797 10.4474 0.306131 10.2814 0.511821 10.1934C0.717512 10.1054 0.949719 10.1027 1.15739 10.1859L4.12233 11.3722C4.72572 11.6136 5.39881 11.6136 6.0022 11.3722L7.71333 10.6871C8.71915 10.2848 9.84119 10.2848 10.847 10.6871L12.5598 11.3722C13.1632 11.6136 13.8363 11.6136 14.4397 11.3722L16.1508 10.6871C17.1566 10.2848 18.2787 10.2848 19.2845 10.6871L20.9973 11.3722C21.6007 11.6136 22.2738 11.6136 22.8772 11.3722L25.8421 10.1859C25.9455 10.142 26.0565 10.1191 26.1688 10.1187C26.2811 10.1182 26.3923 10.1401 26.496 10.1832C26.5997 10.2263 26.6937 10.2896 26.7726 10.3695C26.8515 10.4494 26.9137 10.5442 26.9555 10.6485C26.9972 10.7527 27.0178 10.8642 27.0159 10.9764C27.0141 11.0887 26.9898 11.1995 26.9446 11.3022C26.8994 11.405 26.8341 11.4977 26.7526 11.5749C26.6711 11.6522 26.575 11.7123 26.4699 11.7519L23.5033 12.9382C22.4974 13.3406 21.3754 13.3406 20.3696 12.9382L18.6585 12.2531C18.0551 12.0118 17.382 12.0118 16.7786 12.2531L15.0658 12.9382C14.0599 13.3406 12.9379 13.3406 11.9321 12.9382L10.221 12.2531C9.61756 12.0118 8.94447 12.0118 8.34108 12.2531L6.62826 12.9382C5.62244 13.3406 4.5004 13.3406 3.49458 12.9382L0.529638 11.7519C0.322005 11.6686 0.155947 11.5063 0.0679747 11.3006C-0.0199975 11.0949 -0.0226814 10.8627 0.060513 10.6551ZM0.060513 15.7176C0.143797 15.5099 0.306131 15.3439 0.511821 15.2559C0.717512 15.1679 0.949719 15.1652 1.15739 15.2484L4.12233 16.4347C4.72572 16.6761 5.39881 16.6761 6.0022 16.4347L7.71333 15.7496C8.71915 15.3473 9.84119 15.3473 10.847 15.7496L12.5598 16.4347C13.1632 16.6761 13.8363 16.6761 14.4397 16.4347L16.1508 15.7496C17.1566 15.3473 18.2787 15.3473 19.2845 15.7496L20.9973 16.4347C21.6007 16.6761 22.2738 16.6761 22.8772 16.4347L25.8421 15.2484C25.9455 15.2045 26.0565 15.1816 26.1688 15.1812C26.2811 15.1807 26.3923 15.2026 26.496 15.2457C26.5997 15.2888 26.6937 15.3521 26.7726 15.432C26.8515 15.5119 26.9137 15.6067 26.9555 15.711C26.9972 15.8152 27.0178 15.9267 27.0159 16.0389C27.0141 16.1512 26.9898 16.262 26.9446 16.3647C26.8994 16.4675 26.8341 16.5602 26.7526 16.6374C26.6711 16.7147 26.575 16.7748 26.4699 16.8144L23.5033 18.0007C22.4974 18.4031 21.3754 18.4031 20.3696 18.0007L18.6585 17.3156C18.0551 17.0743 17.382 17.0743 16.7786 17.3156L15.0658 18.0007C14.0599 18.4031 12.9379 18.4031 11.9321 18.0007L10.221 17.3156C9.61756 17.0743 8.94447 17.0743 8.34108 17.3156L6.62826 18.0007C5.62244 18.4031 4.5004 18.4031 3.49458 18.0007L0.529638 16.8144C0.322005 16.7311 0.155947 16.5688 0.0679747 16.3631C-0.0199975 16.1574 -0.0226814 15.9252 0.060513 15.7176ZM0.060513 20.7801C0.143797 20.5724 0.306131 20.4064 0.511821 20.3184C0.717512 20.2304 0.949719 20.2277 1.15739 20.3109L4.12233 21.4972C4.72572 21.7386 5.39881 21.7386 6.0022 21.4972L7.71333 20.8121C8.71915 20.4098 9.84119 20.4098 10.847 20.8121L12.5598 21.4972C13.1632 21.7386 13.8363 21.7386 14.4397 21.4972L16.1508 20.8121C17.1566 20.4098 18.2787 20.4098 19.2845 20.8121L20.9973 21.4972C21.6007 21.7386 22.2738 21.7386 22.8772 21.4972L25.8421 20.3109C25.9455 20.267 26.0565 20.2441 26.1688 20.2437C26.2811 20.2432 26.3923 20.2651 26.496 20.3082C26.5997 20.3513 26.6937 20.4146 26.7726 20.4945C26.8515 20.5744 26.9137 20.6692 26.9555 20.7735C26.9972 20.8777 27.0178 20.9892 27.0159 21.1014C27.0141 21.2137 26.9898 21.3245 26.9446 21.4272C26.8994 21.53 26.8341 21.6227 26.7526 21.6999C26.6711 21.7772 26.575 21.8373 26.4699 21.8769L23.5033 23.0632C22.4974 23.4656 21.3754 23.4656 20.3696 23.0632L18.6585 22.3781C18.0551 22.1368 17.382 22.1368 16.7786 22.3781L15.0658 23.0632C14.0599 23.4656 12.9379 23.4656 11.9321 23.0632L10.221 22.3781C9.61756 22.1368 8.94447 22.1368 8.34108 22.3781L6.62826 23.0632C5.62244 23.4656 4.5004 23.4656 3.49458 23.0632L0.529638 21.8769C0.322005 21.7936 0.155947 21.6313 0.0679747 21.4256C-0.0199975 21.2199 -0.0226814 20.9877 0.060513 20.7801Z"
              fill="#1A4D6D"
            />
          </g>
          <defs>
            <clipPath id="clip0_1222_2752">
              <rect width="27" height="27" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    4: {
      title: "Helipad",
      name: "helipad",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M18 9V15H14V9H12V23H14V17H18V23H20V9H18Z" fill="#1A4D6D" />
          <path
            d="M16 30C13.2311 30 10.5243 29.1789 8.22202 27.6406C5.91973 26.1022 4.12532 23.9157 3.06569 21.3576C2.00607 18.7994 1.72882 15.9845 2.26901 13.2687C2.80921 10.553 4.14258 8.05845 6.10051 6.10051C8.05845 4.14258 10.553 2.80921 13.2687 2.26901C15.9845 1.72882 18.7994 2.00607 21.3576 3.06569C23.9157 4.12532 26.1022 5.91973 27.6406 8.22202C29.1789 10.5243 30 13.2311 30 16C29.9958 19.7117 28.5194 23.2702 25.8948 25.8948C23.2702 28.5194 19.7117 29.9958 16 30ZM16 4.00001C13.6266 4.00001 11.3066 4.70379 9.33316 6.02237C7.35977 7.34095 5.8217 9.21509 4.91345 11.4078C4.0052 13.6005 3.76756 16.0133 4.23058 18.3411C4.69361 20.6689 5.83649 22.8071 7.51472 24.4853C9.19296 26.1635 11.3312 27.3064 13.6589 27.7694C15.9867 28.2325 18.3995 27.9948 20.5922 27.0866C22.7849 26.1783 24.6591 24.6402 25.9776 22.6668C27.2962 20.6935 28 18.3734 28 16C27.9963 12.8185 26.7308 9.76845 24.4812 7.51882C22.2316 5.26918 19.1815 4.00371 16 4.00001Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    5: {
      title: "Piano",
      name: "piano",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="29"
          height="30"
          viewBox="0 0 29 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M26.5835 26.25C27.2244 26.25 27.8391 25.9866 28.2923 25.5178C28.7455 25.0489 29.0002 24.413 29.0002 23.75V6.25C29.0002 5.58696 28.7455 4.95107 28.2923 4.48223C27.8391 4.01339 27.2244 3.75 26.5835 3.75H3.62516C2.98422 3.75 2.36953 4.01339 1.91632 4.48223C1.46311 4.95107 1.2085 5.58696 1.2085 6.25V23.75C1.2085 24.413 1.46311 25.0489 1.91632 25.5178C2.36953 25.9866 2.98422 26.25 3.62516 26.25H26.5835ZM13.2918 6.25H10.857V16.25H9.6487V23.75H14.5002V16.25H13.2918V6.25ZM21.7683 23.75H26.5835V6.25H22.9766V16.25H21.7683V23.75ZM20.56 16.25H19.3516V6.25H16.9168V16.25H15.7085V23.75H20.56V16.25ZM8.44037 23.75V16.25H7.23204V6.25H3.62516V23.75H8.44037Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    6: {
      title: "Gymnasium",
      name: "gymnasium",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="31"
          height="31"
          viewBox="0 0 31 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.55817 9.0415H5.9415C5.73596 9.0415 5.53884 9.12316 5.3935 9.2685C5.24816 9.41384 5.1665 9.61096 5.1665 9.8165V21.1832C5.1665 21.2849 5.18655 21.3857 5.2255 21.4797C5.26444 21.5738 5.32153 21.6592 5.3935 21.7312C5.46546 21.8031 5.5509 21.8602 5.64492 21.8992C5.73895 21.9381 5.83973 21.9582 5.9415 21.9582H9.55817C9.65995 21.9582 9.76072 21.9381 9.85475 21.8992C9.94878 21.8602 10.0342 21.8031 10.1062 21.7312C10.1781 21.6592 10.2352 21.5738 10.2742 21.4797C10.3131 21.3857 10.3332 21.2849 10.3332 21.1832V9.8165C10.3332 9.61096 10.2515 9.41384 10.1062 9.2685C9.96084 9.12316 9.76371 9.0415 9.55817 9.0415V9.0415ZM25.0582 9.0415H21.4415C21.236 9.0415 21.0388 9.12316 20.8935 9.2685C20.7482 9.41384 20.6665 9.61096 20.6665 9.8165V21.1832C20.6665 21.2849 20.6865 21.3857 20.7255 21.4797C20.7644 21.5738 20.8215 21.6592 20.8935 21.7312C20.9655 21.8031 21.0509 21.8602 21.1449 21.8992C21.239 21.9381 21.3397 21.9582 21.4415 21.9582H25.0582C25.1599 21.9582 25.2607 21.9381 25.3547 21.8992C25.4488 21.8602 25.5342 21.8031 25.6062 21.7312C25.6781 21.6592 25.7352 21.5738 25.7742 21.4797C25.8131 21.3857 25.8332 21.2849 25.8332 21.1832V9.8165C25.8332 9.61096 25.7515 9.41384 25.6062 9.2685C25.4608 9.12316 25.2637 9.0415 25.0582 9.0415V9.0415Z"
            stroke="#1A4D6D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.3332 15.5H20.6665M1.2915 18.6V12.4C1.2915 12.1945 1.37316 11.9973 1.5185 11.852C1.66384 11.7067 1.86096 11.625 2.0665 11.625H4.3915C4.59705 11.625 4.79417 11.7067 4.93951 11.852C5.08485 11.9973 5.1665 12.1945 5.1665 12.4V18.6C5.1665 18.8055 5.08485 19.0027 4.93951 19.148C4.79417 19.2933 4.59705 19.375 4.3915 19.375H2.0665C1.86096 19.375 1.66384 19.2933 1.5185 19.148C1.37316 19.0027 1.2915 18.8055 1.2915 18.6V18.6ZM29.7082 18.6V12.4C29.7082 12.1945 29.6265 11.9973 29.4812 11.852C29.3358 11.7067 29.1387 11.625 28.9332 11.625H26.6082C26.4026 11.625 26.2055 11.7067 26.0602 11.852C25.9148 11.9973 25.8332 12.1945 25.8332 12.4V18.6C25.8332 18.8055 25.9148 19.0027 26.0602 19.148C26.2055 19.2933 26.4026 19.375 26.6082 19.375H28.9332C29.1387 19.375 29.3358 19.2933 29.4812 19.148C29.6265 19.0027 29.7082 18.8055 29.7082 18.6V18.6Z"
            stroke="#1A4D6D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
    },
    7: {
      title: "Elevator",
      name: "elevator",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="25"
          height="34"
          viewBox="0 0 25 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.5 0.256348L0.3125 10.5194V15.2188H24.6875V10.5194L12.5 0.256348ZM22.25 12.8438H2.75V11.6058L12.5 3.3958L22.25 11.6058V12.8438ZM0.3125 23.4808L12.5 33.7438L24.6875 23.4808V18.7813H0.3125V23.4808ZM2.75 21.1563H22.25V22.3944L12.5 30.6044L2.75 22.3944V21.1563Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    8: {
      title: "Indoor cinema",
      name: "indoor_cinema",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="36"
          height="33"
          viewBox="0 0 36 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.99219 13.2163H31.8752V26.6556C31.8752 27.3235 31.5857 27.964 31.0705 28.4363C30.5553 28.9085 29.8566 29.1739 29.1279 29.1739H7.73944C7.01082 29.1739 6.31205 28.9085 5.79684 28.4363C5.28163 27.964 4.99219 27.3235 4.99219 26.6556V13.2163V13.2163Z"
            stroke="#1A4D6D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M22.5223 20.9109L16.703 17.5641C16.6476 17.5321 16.5838 17.5144 16.5183 17.5127C16.4529 17.511 16.3881 17.5254 16.3308 17.5545C16.2735 17.5836 16.2257 17.6262 16.1925 17.678C16.1593 17.7297 16.1419 17.7887 16.142 17.8488V24.5423C16.1419 24.6023 16.1593 24.6613 16.1925 24.713C16.2257 24.7648 16.2735 24.8074 16.3308 24.8365C16.3881 24.8656 16.4529 24.88 16.5183 24.8783C16.5838 24.8766 16.6476 24.8589 16.703 24.8269L22.5223 21.4801C22.575 21.45 22.6184 21.408 22.6486 21.3582C22.6787 21.3084 22.6945 21.2524 22.6945 21.1955C22.6945 21.1386 22.6787 21.0826 22.6486 21.0328C22.6184 20.983 22.575 20.941 22.5223 20.9109V20.9109ZM28.1405 4.07057L27.3485 7.00482L23.4298 7.6655L24.2218 4.73194L20.1365 5.42082L19.3438 8.35506L15.425 9.01575L16.217 6.08219L12.1318 6.77106L11.3398 9.70463L7.42103 10.366L8.21303 7.43244L4.87478 7.9955C4.75644 8.01536 4.64353 8.05641 4.54252 8.11631C4.44151 8.17621 4.35437 8.25378 4.2861 8.34459C4.21783 8.43539 4.16977 8.53765 4.14466 8.6455C4.11955 8.75335 4.11789 8.86469 4.13978 8.97313L4.99178 13.2171L31.4308 8.75725L30.5788 4.51332C30.557 4.40488 30.5122 4.30143 30.4468 4.20888C30.3814 4.11633 30.2968 4.03649 30.1978 3.97393C30.0987 3.91136 29.9872 3.86729 29.8696 3.84424C29.752 3.82119 29.6306 3.8196 29.5123 3.83957L28.1405 4.07057Z"
            stroke="#1A4D6D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
    },
    9: {
      title: "Conference room",
      name: "conference_room",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="32"
          height="29"
          viewBox="0 0 32 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.33317 12.0832H11.9998C12.3535 12.0832 12.6926 11.9559 12.9426 11.7293C13.1927 11.5027 13.3332 11.1953 13.3332 10.8748C13.3332 10.5544 13.1927 10.247 12.9426 10.0204C12.6926 9.79381 12.3535 9.6665 11.9998 9.6665H9.33317C8.97955 9.6665 8.64041 9.79381 8.39036 10.0204C8.14031 10.247 7.99984 10.5544 7.99984 10.8748C7.99984 11.1953 8.14031 11.5027 8.39036 11.7293C8.64041 11.9559 8.97955 12.0832 9.33317 12.0832ZM27.9998 4.83317H17.3332V3.62484C17.3332 3.30437 17.1927 2.99702 16.9426 2.77042C16.6926 2.54381 16.3535 2.4165 15.9998 2.4165C15.6462 2.4165 15.3071 2.54381 15.057 2.77042C14.807 2.99702 14.6665 3.30437 14.6665 3.62484V4.83317H3.99984C3.64622 4.83317 3.30708 4.96048 3.05703 5.18708C2.80698 5.41369 2.6665 5.72103 2.6665 6.0415V18.1248C2.6665 19.0862 3.08793 20.0083 3.83808 20.6881C4.58822 21.3679 5.60564 21.7498 6.6665 21.7498H12.7865L9.71984 24.5169C9.59487 24.6293 9.49567 24.7629 9.42798 24.9101C9.36029 25.0574 9.32544 25.2153 9.32544 25.3748C9.32544 25.5344 9.36029 25.6923 9.42798 25.8395C9.49567 25.9868 9.59487 26.1204 9.71984 26.2328C9.84379 26.346 9.99126 26.4359 10.1537 26.4972C10.3162 26.5586 10.4905 26.5902 10.6665 26.5902C10.8425 26.5902 11.0168 26.5586 11.1793 26.4972C11.3418 26.4359 11.4892 26.346 11.6132 26.2328L14.6665 23.4536V25.3748C14.6665 25.6953 14.807 26.0027 15.057 26.2293C15.3071 26.4559 15.6462 26.5832 15.9998 26.5832C16.3535 26.5832 16.6926 26.4559 16.9426 26.2293C17.1927 26.0027 17.3332 25.6953 17.3332 25.3748V23.4536L20.3865 26.2328C20.5105 26.346 20.6579 26.4359 20.8204 26.4972C20.9829 26.5586 21.1572 26.5902 21.3332 26.5902C21.5092 26.5902 21.6835 26.5586 21.8459 26.4972C22.0084 26.4359 22.1559 26.346 22.2798 26.2328C22.4048 26.1204 22.504 25.9868 22.5717 25.8395C22.6394 25.6923 22.6742 25.5344 22.6742 25.3748C22.6742 25.2153 22.6394 25.0574 22.5717 24.9101C22.504 24.7629 22.4048 24.6293 22.2798 24.5169L19.2132 21.7498H25.3332C26.394 21.7498 27.4115 21.3679 28.1616 20.6881C28.9117 20.0083 29.3332 19.0862 29.3332 18.1248V6.0415C29.3332 5.72103 29.1927 5.41369 28.9426 5.18708C28.6926 4.96048 28.3535 4.83317 27.9998 4.83317ZM26.6665 18.1248C26.6665 18.4453 26.526 18.7527 26.276 18.9793C26.0259 19.2059 25.6868 19.3332 25.3332 19.3332H6.6665C6.31288 19.3332 5.97374 19.2059 5.7237 18.9793C5.47365 18.7527 5.33317 18.4453 5.33317 18.1248V7.24984H26.6665V18.1248ZM9.33317 16.9165H17.3332C17.6868 16.9165 18.0259 16.7892 18.276 16.5626C18.526 16.336 18.6665 16.0286 18.6665 15.7082C18.6665 15.3877 18.526 15.0804 18.276 14.8538C18.0259 14.6271 17.6868 14.4998 17.3332 14.4998H9.33317C8.97955 14.4998 8.64041 14.6271 8.39036 14.8538C8.14031 15.0804 7.99984 15.3877 7.99984 15.7082C7.99984 16.0286 8.14031 16.336 8.39036 16.5626C8.64041 16.7892 8.97955 16.9165 9.33317 16.9165Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    10: {
      title: "Outdoor cinema",
      name: "outdoor_cinema",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="36"
          height="33"
          viewBox="0 0 36 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.99219 13.2163H31.8752V26.6556C31.8752 27.3235 31.5857 27.964 31.0705 28.4363C30.5553 28.9085 29.8566 29.1739 29.1279 29.1739H7.73944C7.01082 29.1739 6.31205 28.9085 5.79684 28.4363C5.28163 27.964 4.99219 27.3235 4.99219 26.6556V13.2163V13.2163Z"
            stroke="#1A4D6D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M22.5223 20.9109L16.703 17.5641C16.6476 17.5321 16.5838 17.5144 16.5183 17.5127C16.4529 17.511 16.3881 17.5254 16.3308 17.5545C16.2735 17.5836 16.2257 17.6262 16.1925 17.678C16.1593 17.7297 16.1419 17.7887 16.142 17.8488V24.5423C16.1419 24.6023 16.1593 24.6613 16.1925 24.713C16.2257 24.7648 16.2735 24.8074 16.3308 24.8365C16.3881 24.8656 16.4529 24.88 16.5183 24.8783C16.5838 24.8766 16.6476 24.8589 16.703 24.8269L22.5223 21.4801C22.575 21.45 22.6184 21.408 22.6486 21.3582C22.6787 21.3084 22.6945 21.2524 22.6945 21.1955C22.6945 21.1386 22.6787 21.0826 22.6486 21.0328C22.6184 20.983 22.575 20.941 22.5223 20.9109V20.9109ZM28.1405 4.07057L27.3485 7.00482L23.4298 7.6655L24.2218 4.73194L20.1365 5.42082L19.3438 8.35506L15.425 9.01575L16.217 6.08219L12.1318 6.77106L11.3398 9.70463L7.42103 10.366L8.21303 7.43244L4.87478 7.9955C4.75644 8.01536 4.64353 8.05641 4.54252 8.11631C4.44151 8.17621 4.35437 8.25378 4.2861 8.34459C4.21783 8.43539 4.16977 8.53765 4.14466 8.6455C4.11955 8.75335 4.11789 8.86469 4.13978 8.97313L4.99178 13.2171L31.4308 8.75725L30.5788 4.51332C30.557 4.40488 30.5122 4.30143 30.4468 4.20888C30.3814 4.11633 30.2968 4.03649 30.1978 3.97393C30.0987 3.91136 29.9872 3.86729 29.8696 3.84424C29.752 3.82119 29.6306 3.8196 29.5123 3.83957L28.1405 4.07057Z"
            stroke="#1A4D6D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
    },
    11: {
      title: "Office room",
      name: "office_room",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="31"
          height="26"
          viewBox="0 0 31 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.0835 6.49984V4.33317H12.9168V6.49984H18.0835ZM5.16683 8.6665V20.5832H25.8335V8.6665H5.16683ZM25.8335 6.49984C27.2672 6.49984 28.4168 7.464 28.4168 8.6665V20.5832C28.4168 21.7857 27.2672 22.7498 25.8335 22.7498H5.16683C3.73308 22.7498 2.5835 21.7857 2.5835 20.5832L2.59641 8.6665C2.59641 7.464 3.73308 6.49984 5.16683 6.49984H10.3335V4.33317C10.3335 3.13067 11.4831 2.1665 12.9168 2.1665H18.0835C19.5172 2.1665 20.6668 3.13067 20.6668 4.33317V6.49984H25.8335Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    // 12: {
    //   title: "Helicopter",
    //   name: "helicopter",
    //   input: false,
    //   input_value: "",
    //   suggest_feature: false,
    //   icon: null,
    // },

    12: {
      title: "Massage room",
      name: "massage_room",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="35"
          height="36"
          viewBox="0 0 35 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.2085 12.75C10.2085 12.3522 10.3621 11.9706 10.6356 11.6893C10.9091 11.408 11.2801 11.25 11.6668 11.25H30.6252C31.0119 11.25 31.3829 11.408 31.6564 11.6893C31.9299 11.9706 32.0835 12.3522 32.0835 12.75V17.25H10.2085V12.75Z"
            stroke="#1A4D6D"
            stroke-width="4"
            stroke-linejoin="round"
          />
          <path
            d="M6.5625 10.5L2.1875 9M18.9583 17.25L10.2083 27.75L18.9583 17.25ZM23.3333 17.25L32.0833 27.75L23.3333 17.25ZM10.2083 17.25H4.375H10.2083ZM28.4375 23.25H13.8542H28.4375ZM4.375 9.75V17.25V9.75ZM10.2083 17.25V30V17.25ZM32.0833 17.25V30V17.25Z"
            stroke="#1A4D6D"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
    },
    13: {
      title: "Cocktail bar",
      name: "cocktail_bar",
      input: false,
      input_value: "",
      suggest_feature: false,
      icon: (
        <svg
          width="23"
          height="28"
          viewBox="0 0 23 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.5125 0H0V1.64062H4.33125L5.97187 6.5625H7.69453L5.5125 0Z"
            fill="#1A4D6D"
          />
          <path
            d="M15.586 17.2265C15.586 16.4382 15.4194 15.6476 15.1054 14.941L15.1038 14.9394C14.7161 14.0734 14.6344 13.0329 14.8619 11.937C14.8951 11.783 14.9472 11.6365 14.9876 11.4844H4.69217C5.00898 12.6622 4.95505 13.9445 4.48458 15.163C4.10007 16.1708 4.0007 17.2546 4.19621 18.2928C4.60576 20.5244 6.4658 22.5404 9.02353 22.8931V26.3593H4.92197V27.9999H14.7657V26.3593H10.6642V22.8907C13.5875 22.4656 15.586 19.9961 15.586 17.2265Z"
            fill="#1A4D6D"
          />
          <path
            d="M4.13447 9.84375H7.07114L5.97192 6.5625H2.92041L4.13447 9.84375Z"
            fill="#1A4D6D"
          />
          <path
            d="M15.5529 9.84375L16.7669 6.5625H7.69434L8.79355 9.84375H15.5529Z"
            fill="#1A4D6D"
          />
          <path
            d="M16.4065 1.64062C14.1246 1.64062 12.1656 2.98895 11.2402 4.92188H19.1269L16.6788 11.506C16.5907 11.748 16.5234 12.0155 16.4657 12.2831C16.4044 12.5785 16.3997 12.8545 16.4009 13.1266C16.4054 13.1266 16.41 13.1282 16.4144 13.1282C17.4959 13.1282 18.5485 12.8286 19.4842 12.2334C21.1521 11.1728 22.1486 9.35988 22.1486 7.38281C22.1486 4.2169 19.5724 1.64062 16.4065 1.64062Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    14: {
      title: "Suggest Feature",
      name: "lux_suggest_feature",
      input: false,
      suggest_feature: true,
      input_value: "",
    },
  };

  // =============================== features List ==================
  const [featuresList, setFeaturesList] = useState(featuresDataList);

  // ======================= luxury features List ===========================
  const [luxury_featuresList, setLuxury_FeaturesList] =
    useState(luxury_dataList);

  // opt cph data
  const [opt_cph_, set_opt_cph_] = useState({
    0: {
      active: false,
      title: "Transfers",
      name: "transfer",
      opt: true,
      cph: false,
      input_value: "",
      icon: (
        <svg
          width="38"
          height="26"
          viewBox="0 0 38 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1222_3008)">
            <path
              d="M28.6988 26.0001V22.4273H8.78345V26.0001H1.73556V16.5448C1.7769 14.8079 2.52542 13.1574 3.81774 11.9536L3.81998 11.9514L1.78251 11.6264C1.2856 11.547 0.833876 11.2992 0.507673 10.9273C0.181469 10.5554 0.00192759 10.0834 0.000976751 9.59519C0.000846535 9.29566 0.0681623 8.99971 0.198225 8.728C0.328287 8.45629 0.517962 8.21537 0.754009 8.02205C0.990056 7.82874 1.26679 7.68769 1.56488 7.60875C1.86298 7.52981 2.17526 7.51489 2.47992 7.56502L2.46762 7.56286L5.96251 8.11536C6.01951 8.12619 6.06868 8.13919 6.11562 8.15436L6.1078 8.15219L8.35874 2.59902H15.5497L16.0862 -0.000976562H22.792L23.3285 2.59902H30.1037L32.3557 8.15652C32.3996 8.14172 32.4444 8.12977 32.4899 8.12077L32.4988 8.11969L35.997 7.56719C36.5507 7.48119 37.1171 7.61029 37.5732 7.92647C38.0294 8.24265 38.3385 8.72042 38.4335 9.25611L38.4357 9.26802C38.5248 9.80401 38.3924 10.3524 38.067 10.7943C37.7417 11.2362 37.2497 11.536 36.6978 11.6286L36.6855 11.6308L33.8556 12.0804C35.0641 13.2731 35.759 14.867 35.7992 16.5383V20.5618C35.7992 20.7015 35.7824 20.8369 35.7512 20.9669L35.7534 20.955V25.9979L28.6988 26.0001ZM24.3579 17.7484C24.3587 18.1118 24.5081 18.4602 24.7733 18.7172C25.0384 18.9742 25.3978 19.119 25.7728 19.1199H31.4583C31.8335 19.1199 32.1934 18.9754 32.4588 18.7182C32.7241 18.4609 32.8732 18.1121 32.8732 17.7484C32.8732 17.3846 32.7241 17.0358 32.4588 16.7786C32.1934 16.5214 31.8335 16.3769 31.4583 16.3769H25.775C25.4001 16.378 25.0409 16.5229 24.7758 16.7798C24.5107 17.0368 24.3613 17.385 24.3601 17.7484H24.3579ZM4.52521 17.7484C4.5258 18.1119 4.67507 18.4604 4.94029 18.7175C5.20552 18.9746 5.56507 19.1193 5.94015 19.1199H11.6256C12.0009 19.1199 12.3608 18.9754 12.6261 18.7182C12.8915 18.4609 13.0406 18.1121 13.0406 17.7484C13.0406 17.3846 12.8915 17.0358 12.6261 16.7786C12.3608 16.5214 12.0009 16.3769 11.6256 16.3769H5.94127C5.56656 16.378 5.20752 16.5227 4.94245 16.7794C4.67739 17.0362 4.5278 17.3841 4.52633 17.7473L4.52521 17.7484ZM7.84798 10.5897H30.496C30.534 10.5897 30.5709 10.5962 30.6066 10.5962L28.3713 5.06469H10.0933L7.84798 10.5897Z"
              fill="#1A4D6D"
            />
          </g>
          <defs>
            <clipPath id="clip0_1222_3008">
              <rect width="38" height="26" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    1: {
      active: false,
      title: "Skipper",
      name: "skipper",
      opt: true,
      cph: false,
      input_value: "",
      icon: (
        <svg
          width="31"
          height="26"
          viewBox="0 0 31 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M31 12.1132C31 9.16986 29.311 6.12657 26.366 3.76362C23.3411 1.33662 19.4822 0 15.5 0C11.5179 0 7.65892 1.33662 4.63402 3.76362C1.68907 6.12657 0 9.16986 0 12.1132V12.5119L1.76132 14.3048H29.3523L31 12.5034V12.1132ZM15.5566 12.141C13.574 12.141 11.961 10.4303 11.961 8.32772H13.7764C13.7764 9.01731 14.127 9.62141 14.6489 9.9509V6.67509H13.3971V4.74977H14.6489V3.17595H16.4644V4.74977H17.7163V6.67509H16.4644V9.9509C16.9863 9.62141 17.3369 9.01725 17.3369 8.32772H19.1524C19.1523 10.4303 17.5393 12.141 15.5566 12.141Z"
            fill="#1A4D6D"
          />
          <path
            d="M2.97388 16.2305H28.1145V18.2556H2.97388V16.2305Z"
            fill="#1A4D6D"
          />
          <path
            d="M2.97388 20.1812V20.2263L2.99796 21.3849C2.99796 23.9301 4.94882 26.0006 7.34677 26.0006H23.7656C26.1635 26.0006 28.1144 23.93 28.1144 21.3849V20.1812H2.97388Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    2: {
      active: false,
      title: "Fuel costs",
      name: "fuel_costs",
      opt: true,
      cph: false,
      input_value: "",
      icon: (
        <svg
          width="38"
          height="36"
          viewBox="0 0 38 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.2379 34.0002H6.22786C5.83042 34.0122 5.43448 33.9485 5.06358 33.8127C4.69268 33.6768 4.35439 33.4718 4.06882 33.2096C3.78325 32.9475 3.55623 32.6336 3.40126 32.2867C3.2463 31.9398 3.16654 31.5669 3.16675 31.1902V4.86016C3.197 4.09264 3.5474 3.36783 4.14107 2.84477C4.73474 2.32172 5.52319 2.04314 6.33342 2.07016H21.3434C21.732 2.06191 22.1184 2.12851 22.4791 2.26593C22.8397 2.40335 23.1672 2.60872 23.4415 2.8696C23.7159 3.13048 23.9315 3.44142 24.0753 3.78358C24.219 4.12575 24.288 4.49201 24.2779 4.86016V31.1902C24.2765 31.5647 24.1965 31.9353 24.0423 32.2803C23.8881 32.6252 23.663 32.9376 23.38 33.1992C23.097 33.4608 22.7618 33.6664 22.394 33.8039C22.0262 33.9414 21.6332 34.0081 21.2379 34.0002ZM6.22786 4.00016C6.10551 3.99615 5.98355 4.01536 5.86914 4.05666C5.75474 4.09796 5.65021 4.16051 5.5617 4.24064C5.47319 4.32076 5.40248 4.41685 5.35374 4.52324C5.30499 4.62963 5.27919 4.74418 5.27786 4.86016V31.1902C5.27786 31.4209 5.37461 31.6422 5.54683 31.8053C5.71905 31.9685 5.95264 32.0602 6.19619 32.0602H21.2379C21.4905 32.0634 21.7349 31.9751 21.9213 31.8135C22.1076 31.6518 22.2218 31.4289 22.2406 31.1902V4.86016C22.2193 4.62323 22.104 4.40277 21.9179 4.24319C21.7318 4.08361 21.4888 3.99677 21.2379 4.00016H6.22786Z"
            fill="#1A4D6D"
          />
          <path
            d="M31.1705 34C30.6827 34.004 30.1989 33.9164 29.747 33.7422C29.2951 33.5681 28.8841 33.3109 28.5377 32.9855C28.1912 32.6601 27.9163 32.273 27.7286 31.8464C27.541 31.4198 27.4444 30.9622 27.4444 30.5V23C27.4444 22.4696 27.222 21.9609 26.8261 21.5858C26.4302 21.2107 25.8932 21 25.3333 21H23.8239C23.5439 21 23.2754 20.8946 23.0775 20.7071C22.8795 20.5196 22.7683 20.2652 22.7683 20C22.7683 19.7348 22.8795 19.4804 23.0775 19.2929C23.2754 19.1054 23.5439 19 23.8239 19H25.3333C26.4531 19 27.5271 19.4214 28.3189 20.1716C29.1107 20.9217 29.5555 21.9391 29.5555 23V30.5C29.5555 30.8978 29.7223 31.2794 30.0193 31.5607C30.3162 31.842 30.7189 32 31.1389 32C31.5588 32 31.9615 31.842 32.2585 31.5607C32.5554 31.2794 32.7222 30.8978 32.7222 30.5V17.3L29.4183 10.3C29.2209 9.90992 28.9109 9.58079 28.5242 9.35072C28.1375 9.12064 27.6899 8.99905 27.2333 9H26.4628C26.1828 9 25.9143 8.89464 25.7164 8.70711C25.5184 8.51957 25.4072 8.26522 25.4072 8C25.4072 7.73478 25.5184 7.48043 25.7164 7.29289C25.9143 7.10536 26.1828 7 26.4628 7H27.2333C28.111 6.99957 28.97 7.24022 29.7062 7.69281C30.4425 8.14539 31.0245 8.7905 31.3816 9.55L34.77 16.71C34.8319 16.8388 34.8643 16.9785 34.865 17.12V30.5C34.865 31.4283 34.4757 32.3185 33.7829 32.9749C33.0901 33.6313 32.1504 34 31.1705 34Z"
            fill="#1A4D6D"
          />
          <path
            d="M19 9H8.44447C8.16452 9 7.89604 8.89464 7.69808 8.70711C7.50013 8.51957 7.38892 8.26522 7.38892 8C7.38892 7.73478 7.50013 7.48043 7.69808 7.29289C7.89604 7.10536 8.16452 7 8.44447 7H19C19.28 7 19.5485 7.10536 19.7464 7.29289C19.9444 7.48043 20.0556 7.73478 20.0556 8C20.0556 8.26522 19.9444 8.51957 19.7464 8.70711C19.5485 8.89464 19.28 9 19 9Z"
            fill="#1A4D6D"
          />
          <path
            d="M19 13H8.44447C8.16452 13 7.89604 12.8946 7.69808 12.7071C7.50013 12.5196 7.38892 12.2652 7.38892 12C7.38892 11.7348 7.50013 11.4804 7.69808 11.2929C7.89604 11.1054 8.16452 11 8.44447 11H19C19.28 11 19.5485 11.1054 19.7464 11.2929C19.9444 11.4804 20.0556 11.7348 20.0556 12C20.0556 12.2652 19.9444 12.5196 19.7464 12.7071C19.5485 12.8946 19.28 13 19 13Z"
            fill="#1A4D6D"
          />
          <path
            d="M26.3888 12.0801C26.1089 12.0801 25.8404 11.9747 25.6424 11.7872C25.4445 11.5996 25.3333 11.3453 25.3333 11.0801V5.08008C25.3333 4.81486 25.4445 4.56051 25.6424 4.37297C25.8404 4.18544 26.1089 4.08008 26.3888 4.08008C26.6688 4.08008 26.9372 4.18544 27.1352 4.37297C27.3332 4.56051 27.4444 4.81486 27.4444 5.08008V11.0801C27.4444 11.3453 27.3332 11.5996 27.1352 11.7872C26.9372 11.9747 26.6688 12.0801 26.3888 12.0801Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    3: {
      active: false,
      title: "Pets allowed",
      name: "pets_allowed",
      opt: true,
      cph: false,
      input_value: "",
      icon: (
        <svg
          width="35"
          height="32"
          viewBox="0 0 35 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.56258 16.0002C8.57612 16.0002 10.2084 14.5078 10.2084 12.6668C10.2084 10.8259 8.57612 9.3335 6.56258 9.3335C4.54904 9.3335 2.91675 10.8259 2.91675 12.6668C2.91675 14.5078 4.54904 16.0002 6.56258 16.0002Z"
            fill="#1A4D6D"
          />
          <path
            d="M13.1251 10.6667C15.1386 10.6667 16.7709 9.17428 16.7709 7.33333C16.7709 5.49238 15.1386 4 13.1251 4C11.1115 4 9.47925 5.49238 9.47925 7.33333C9.47925 9.17428 11.1115 10.6667 13.1251 10.6667Z"
            fill="#1A4D6D"
          />
          <path
            d="M21.8751 10.6667C23.8886 10.6667 25.5209 9.17428 25.5209 7.33333C25.5209 5.49238 23.8886 4 21.8751 4C19.8615 4 18.2292 5.49238 18.2292 7.33333C18.2292 9.17428 19.8615 10.6667 21.8751 10.6667Z"
            fill="#1A4D6D"
          />
          <path
            d="M28.4376 16.0002C30.4511 16.0002 32.0834 14.5078 32.0834 12.6668C32.0834 10.8259 30.4511 9.3335 28.4376 9.3335C26.424 9.3335 24.7917 10.8259 24.7917 12.6668C24.7917 14.5078 26.424 16.0002 28.4376 16.0002Z"
            fill="#1A4D6D"
          />
          <path
            d="M25.2876 19.8133C24.0189 18.4533 22.9543 17.2933 21.6709 15.9333C21.0001 15.2133 20.1397 14.4933 19.1189 14.1733C18.9584 14.12 18.798 14.08 18.6376 14.0533C18.273 14 17.8793 14 17.5001 14C17.1209 14 16.7272 14 16.348 14.0667C16.1876 14.0933 16.0272 14.1333 15.8668 14.1867C14.8459 14.5067 14.0001 15.2267 13.3147 15.9467C12.0459 17.3067 10.9814 18.4667 9.69802 19.8267C7.78761 21.5733 5.43969 23.5067 5.87719 26.2133C6.30011 27.5733 7.36469 28.92 9.27511 29.3067C10.3397 29.5067 13.7376 28.72 17.3543 28.72H17.6168C21.2334 28.72 24.6314 29.4933 25.6959 29.3067C27.6064 28.92 28.6709 27.56 29.0939 26.2133C29.5459 23.4933 27.198 21.56 25.2876 19.8133Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    4: {
      active: false,
      title: "Port Fees",
      name: "port_fees",
      opt: true,
      cph: false,
      input_value: "",
      icon: (
        <svg
          width="32"
          height="30"
          viewBox="0 0 32 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.0001 18.75H7.00006C6.84817 18.75 6.69828 18.7825 6.56177 18.8449C6.42526 18.9074 6.30572 18.9982 6.21222 19.1104C6.11872 19.2226 6.05373 19.3534 6.02217 19.4927C5.9906 19.632 5.99331 19.7762 6.03007 19.9143L6.97006 23.4375H9.03006L8.28006 20.625H23.7201L22.9701 23.4375H25.0301L25.9701 19.9143C26.0068 19.7762 26.0095 19.632 25.978 19.4927C25.9464 19.3534 25.8814 19.2226 25.7879 19.1104C25.6944 18.9982 25.5749 18.9074 25.4384 18.8449C25.3019 18.7825 25.152 18.75 25.0001 18.75H14.0001V2.81246C14.0003 2.61562 13.9344 2.4237 13.8117 2.26393C13.6891 2.10415 13.5159 1.98462 13.3168 1.92228C13.1176 1.85994 12.9026 1.85795 12.7021 1.9166C12.5017 1.97524 12.326 2.09155 12.2001 2.24902L2.20906 14.4281C2.0952 14.5668 2.02501 14.7325 2.00643 14.9067C1.98785 15.0808 2.02163 15.2563 2.10394 15.4134C2.18625 15.5704 2.3138 15.7028 2.47217 15.7954C2.63054 15.888 2.8134 15.9372 3.00006 15.9375H12.0001V18.75ZM5.03007 14.0625L12.0001 5.56871V14.0625H5.03007Z"
            fill="#1A4D6D"
          />
          <path
            d="M26.906 24.1418C26.7398 24.7457 26.364 25.2806 25.8379 25.6623C25.3118 26.044 24.6652 26.2508 24 26.2502C23.319 26.2129 22.6653 25.9865 22.122 25.5998C21.5787 25.2132 21.1704 24.6838 20.949 24.079C20.8817 23.8927 20.7541 23.7309 20.584 23.6159C20.4138 23.5009 20.2097 23.4386 20 23.4377C19.7906 23.4363 19.5861 23.4972 19.416 23.6115C19.2458 23.7259 19.1187 23.8879 19.053 24.0743C18.832 24.6801 18.4236 25.2106 17.8799 25.5981C17.3362 25.9856 16.6818 26.2126 16 26.2502C15.319 26.2129 14.6653 25.9865 14.122 25.5998C13.5787 25.2132 13.1704 24.6838 12.949 24.079C12.8817 23.8927 12.7541 23.7309 12.584 23.6159C12.4138 23.5009 12.2097 23.4386 12 23.4377C11.7899 23.4335 11.584 23.4932 11.4133 23.608C11.2425 23.7228 11.1161 23.8864 11.053 24.0743C10.832 24.6801 10.4236 25.2106 9.87991 25.5981C9.3362 25.9856 8.68176 26.2126 7.99996 26.2502C7.3347 26.2508 6.68811 26.044 6.16201 25.6623C5.6359 25.2806 5.26016 24.7457 5.09396 24.1418L3.15796 24.6086C3.43446 25.6154 4.06028 26.5073 4.93689 27.1439C5.8135 27.7806 6.89108 28.1258 7.99996 28.1252C8.77601 28.1316 9.54272 27.9663 10.2378 27.6426C10.9328 27.3189 11.5366 26.846 12 26.2624C12.4681 26.8412 13.0729 27.3106 13.7668 27.6337C14.4608 27.9569 15.2251 28.125 16 28.125C16.7748 28.125 17.5391 27.9569 18.2331 27.6337C18.927 27.3106 19.5318 26.8412 20 26.2624C20.4633 26.846 21.0671 27.3189 21.7621 27.6426C22.4572 27.9663 23.2239 28.1316 24 28.1252C25.1088 28.1258 26.1864 27.7806 27.063 27.1439C27.9396 26.5073 28.5655 25.6154 28.842 24.6086L26.906 24.1418Z"
            fill="#1A4D6D"
          />
          <path
            d="M29.912 13.0641L23.628 2.2228C23.5659 2.11771 23.4749 2.03012 23.3645 1.96913C23.254 1.90814 23.1282 1.87598 23 1.87598C22.8719 1.87598 22.746 1.90814 22.6356 1.96913C22.5252 2.03012 22.4342 2.11771 22.372 2.2228L16.088 13.0641C16.0282 13.1669 15.9979 13.2825 16.0001 13.3996C16.0024 13.5167 16.0371 13.6312 16.1008 13.732C16.1646 13.8327 16.2552 13.9161 16.3638 13.9741C16.4723 14.032 16.5951 14.0625 16.72 14.0625H29.28C29.4049 14.0623 29.5275 14.0317 29.636 13.9737C29.7444 13.9157 29.8349 13.8323 29.8985 13.7316C29.9622 13.6309 29.9968 13.5164 29.999 13.3994C30.0012 13.2823 29.9709 13.1668 29.911 13.0641H29.912ZM22.25 5.62499H23.75V9.37499H22.25V5.62499ZM23 12.1875C22.8023 12.1875 22.6089 12.1325 22.4445 12.0295C22.28 11.9265 22.1518 11.7801 22.0762 11.6088C22.0005 11.4375 21.9807 11.249 22.0193 11.0671C22.0578 10.8852 22.1531 10.7182 22.2929 10.5871C22.4328 10.456 22.611 10.3667 22.8049 10.3305C22.9989 10.2943 23.2 10.3129 23.3827 10.3839C23.5654 10.4548 23.7216 10.575 23.8315 10.7291C23.9414 10.8833 24 11.0646 24 11.25C24 11.4986 23.8947 11.7371 23.7071 11.9129C23.5196 12.0887 23.2653 12.1875 23 12.1875Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    5: {
      active: false,
      title: "Wi-fi",
      name: "Wi_fi",
      opt: true,
      cph: false,
      input_value: "",
      icon: (
        <svg
          width="38"
          height="32"
          viewBox="0 0 38 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.9466 21.9438C16.8477 21.9438 15.1466 23.735 15.1466 25.9444C15.1466 28.1537 16.8483 29.945 18.9466 29.945C21.0449 29.945 22.7466 28.1537 22.7466 25.9444C22.7466 23.735 21.096 21.9438 18.9466 21.9438ZM19 11.9438C14.8289 11.9438 10.8122 13.5438 7.68909 16.4456C6.90534 17.2313 6.82815 18.4938 7.52284 19.325C8.22346 20.15 9.42284 20.2313 10.2066 19.5C12.635 17.2437 15.7582 16 19 16C22.2419 16 25.371 17.2425 27.7935 19.5C28.1556 19.8375 28.6069 20 29.0522 20C29.3217 20.0002 29.5881 19.9401 29.8338 19.8236C30.0795 19.7071 30.2988 19.5369 30.4772 19.3244C31.1719 18.4937 31.1006 17.2312 30.311 16.5C27.1878 13.6 23.1741 11.9438 19 11.9438ZM37.4182 9.79375C32.4366 4.7675 25.8994 2 19 2C12.1006 2 5.56287 4.7675 0.584513 9.79375C-0.172518 10.5594 -0.196862 11.825 0.528819 12.6219C1.25438 13.4206 2.45673 13.4419 3.21554 12.6805C7.42784 8.31875 13.0863 6 19 6C24.9138 6 30.4653 8.37312 34.7819 12.6812C35.156 13.05 35.625 13.2375 36.1 13.2375C36.5991 13.2375 37.0981 13.0324 37.471 12.6222C38.196 11.825 38.1722 10.5062 37.4182 9.79375Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    6: {
      active: false,
      title: "Jet-ski",
      name: "Jet_ski",
      opt: true,
      cph: false,
      input_value: "",
      icon: (
        <svg
          width="35"
          height="37"
          viewBox="0 0 35 37"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.536 8.79718C13.0284 8.607 14.0875 7.14624 13.9111 5.53896C13.7347 3.93094 12.3788 2.7906 10.8864 2.98004C9.39395 3.18058 8.33905 4.63098 8.51545 6.23826C8.70025 7.84702 10.0436 8.98736 11.536 8.79718ZM33.8954 22.6071C33.7512 22.5294 22.6625 16.4628 22.6625 16.4628L19.8471 12.5564L19.6728 12.5127C19.2885 12.1331 18.9 12.1679 18.2 12.5823V12.5912C18.2 12.902 18.0446 13.36 18.2385 13.7322L20.3945 16.6353L20.4372 16.6619L18.7222 20.9391L14.1358 19.7026L13.9398 17.9303L17.7191 17.4389C17.8878 17.4308 18.0649 17.3782 18.2252 17.2835C18.8517 16.9298 19.0925 16.0906 18.7635 15.4172C18.6459 15.1729 18.4612 14.972 18.2335 14.8408C18.0059 14.7096 17.746 14.6544 17.4881 14.6824L13.6388 15.1834L13.2937 12.1072C13.1096 10.5081 11.753 9.35884 10.269 9.54902C8.78145 9.74808 7.71395 11.2096 7.89035 12.8161L8.69255 19.9283C8.74179 20.3627 8.88042 20.7805 9.0987 21.1522C9.31698 21.524 9.60962 21.8407 9.95605 22.0802L3.91015 22.8579L2.02505 27.887L2.24135 27.81C3.02173 27.42 3.87367 27.2161 4.73685 27.2128C5.59385 27.2162 6.43988 27.4167 7.21625 27.8004C7.70555 28.0416 8.24315 28.163 8.76465 28.163C9.29035 28.163 9.81955 28.0416 10.3012 27.8093C11.0812 27.4183 11.9334 27.2144 12.7967 27.2121C13.6506 27.2146 14.4936 27.4152 15.2663 27.7996C15.7633 28.0409 16.3009 28.1622 16.8231 28.1622C17.3523 28.1622 17.8738 28.0409 18.3631 27.8085C19.1415 27.4193 20.0088 27.2113 20.8586 27.2113C21.7084 27.2113 22.5672 27.4185 23.3295 27.7989C23.5143 27.8847 23.7153 27.9454 23.9155 28.0061C27.0046 27.1314 32.4764 25.4479 33.952 24.0219C34.3846 23.609 34.4659 22.909 33.8954 22.6071V22.6071ZM0.699951 34.0401C1.38736 34.0382 2.06624 33.8791 2.69005 33.5739C3.30745 33.2623 4.00605 33.0818 4.73615 33.0818C5.46625 33.0818 6.15645 33.2623 6.78225 33.5739C7.38355 33.8676 8.05765 34.0401 8.76395 34.0401C9.44986 34.0368 10.1271 33.8778 10.7499 33.5739C11.3887 33.2508 12.0878 33.0826 12.796 33.0818C13.5184 33.0818 14.2163 33.2623 14.84 33.5739C15.442 33.8669 16.1161 34.0401 16.8224 34.0401C17.5094 34.0372 18.1879 33.8782 18.8118 33.5739C19.4509 33.2509 20.1502 33.0828 20.8586 33.0818C21.5803 33.0818 22.2788 33.2623 22.8962 33.5739C23.5052 33.8676 24.1794 34.0401 24.885 34.0401C25.592 34.0401 26.2654 33.8676 26.8674 33.5739C27.5069 33.2528 28.2055 33.0848 28.9135 33.0818C29.6429 33.0818 30.3177 33.2623 30.9344 33.5739C31.5364 33.8676 32.2 34.0401 32.9 34.0401V30.8336C32.2 30.8336 31.5364 30.6627 30.9337 30.3682C30.2991 30.0473 29.6043 29.8816 28.9009 29.8835C28.1792 29.8835 27.4869 30.0559 26.8611 30.3682C26.2409 30.6733 25.5654 30.8321 24.8814 30.8336C24.1951 30.8314 23.5172 30.6726 22.8942 30.3682C22.2578 30.0482 21.5618 29.8826 20.8572 29.8835C20.1264 29.8835 19.4292 30.0559 18.8104 30.3682C18.1867 30.6723 17.5085 30.831 16.8217 30.8336C16.137 30.8324 15.4607 30.6735 14.84 30.3682C14.2009 30.0488 13.5028 29.8832 12.796 29.8835C12.0882 29.8816 11.3891 30.0472 10.7499 30.3682C10.1271 30.6719 9.44981 30.8306 8.76395 30.8336C8.07925 30.8325 7.40301 30.6736 6.78225 30.3682C6.15645 30.0559 5.46625 29.8835 4.73615 29.8835C4.00605 29.8835 3.30745 30.0559 2.69005 30.3682C2.0663 30.6735 1.38734 30.8323 0.699951 30.8336V34.0401Z"
            fill="#1A4D6D"
          />
        </svg>
      ),
    },
    7: {
      active: false,
      title: "Catering/Meals",
      name: "catering",
      opt: true,
      cph: false,
      input_value: "",
      icon: (
        <svg
          width="36"
          height="34"
          viewBox="0 0 36 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24 8.50016C24 8.50016 25.5 6.99708 25.5 5.66683C25.5 3.77841 24 2.8335 24 2.8335M12.75 20.5418L7.5 31.1668L12.75 20.5418ZM12 8.50016C12 8.50016 13.5 6.99708 13.5 5.66683C13.5 3.77841 12 2.8335 12 2.8335V8.50016ZM18 8.50016C18 8.50016 19.5 6.99708 19.5 5.66683C19.5 3.77841 18 2.8335 18 2.8335V8.50016Z"
            stroke="#1A4D6D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M24.75 24.792H11.25"
            stroke="#1A4D6D"
            stroke-width="1.5"
            stroke-linejoin="round"
          />
          <path
            d="M23.25 20.542L26.4 26.917L23.25 20.542ZM27.75 31.167C28.3467 31.167 28.919 30.9431 29.341 30.5446C29.7629 30.1461 30 29.6056 30 29.042C30 28.4784 29.7629 27.9379 29.341 27.5394C28.919 27.1409 28.3467 26.917 27.75 26.917C27.1533 26.917 26.581 27.1409 26.159 27.5394C25.7371 27.9379 25.5 28.4784 25.5 29.042C25.5 29.6056 25.7371 30.1461 26.159 30.5446C26.581 30.9431 27.1533 31.167 27.75 31.167Z"
            stroke="#1A4D6D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18 21.2504C20.6292 21.2507 23.1628 20.3194 25.1 18.6406C27.0372 16.9618 28.2371 14.6577 28.4625 12.1837C28.4702 12.0732 28.4535 11.9624 28.4134 11.8583C28.3733 11.7542 28.3107 11.6592 28.2295 11.5792C28.1484 11.4993 28.0505 11.4361 27.9421 11.3939C27.8337 11.3516 27.7172 11.3311 27.6 11.3337H8.39999C8.28275 11.3311 8.16623 11.3516 8.05784 11.3939C7.94944 11.4361 7.85156 11.4993 7.77043 11.5792C7.68929 11.6592 7.62667 11.7542 7.58657 11.8583C7.54646 11.9624 7.52975 12.0732 7.53749 12.1837C7.76284 14.6577 8.96273 16.9618 10.9 18.6406C12.8372 20.3194 15.3708 21.2507 18 21.2504V21.2504Z"
            stroke="#1A4D6D"
            stroke-width="1.5"
          />
        </svg>
      ),
    },
    8: {
      active: false,
      title: "Suggest Feature",
      name: "suggest_feature",
      suggest_feature: true,
      input_value: "",
      icon: null,
    },
  });

  // 0: { active: true, title: 'Paddle Board', name: 'padle_board', opt: true, cph: false, price: '', secondLabel: '€' },
  // 1: { active: true, title: 'SUP', name: 'sup', opt: false, cph: true, price: '', secondLabel: '€/Per Hr' },
  // 2: { active: false, title: 'Kayak', name: 'kayak', opt: false, cph: true, price: '', secondLabel: '€/Per Hr' },
  // 3: { active: false, title: 'Drone Photography Coverage', name: 'photo_graphy_coverage', opt: true, cph: false, price: '', secondLabel: '€' },
  // 4: { active: false, title: 'Yacht Slide', name: 'yacht_slide', opt: true, cph: false, price: '', secondLabel: '€' },
  // 5: { active: false, title: 'Inflatable Climbing wall', name: 'climbing_wall', opt: true, cph: false, price: '', secondLabel: '€' },
  // 6: { active: false, title: 'Yacht Golf', name: 'yacht_golf', opt: true, cph: false, price: '', secondLabel: '€' },
  // 7: { active: false, title: 'Sky Air foilboard', name: 'sky_air_foilboard', opt: true, cph: false, price: '', secondLabel: '€' },
  // 8: { active: false, title: 'Jetski', name: 'jetski', opt: true, cph: false, price: '', secondLabel: '€' },
  // 9: { active: false, title: 'Jumping water bag', name: 'juming_water_bag', opt: true, cph: false, price: '', secondLabel: '€' },
  // 10: { active: false, title: 'Inflatable pool', name: 'inflatable_pool', opt: true, cph: false, price: '', secondLabel: '€' },
  // 11: { active: false, title: 'Inflatable fighting surface', name: 'inflatable_fighting_surface', opt: true, cph: false, price: '', secondLabel: '€' },
  // 12: { active: false, title: 'Massage session', name: 'massage_session', opt: true, cph: false, price: '', secondLabel: '€' },
  // 13: { active: false, title: 'Yoga session', name: 'yoga_session', opt: true, cph: false, price: '', secondLabel: '€' },
  // 14: { active: false, title: 'Gym session ', name: 'gym_session ', opt: true, cph: false, price: '', secondLabel: '€' },
  // 15: { active: false, title: 'Wakeboard', name: 'wakeboard', opt: true, cph: false, price: '', secondLabel: '€' },
  // 16: { active: false, title: 'Parasailing', name: 'parasailing', opt: true, cph: false, price: '', secondLabel: '€' },
  // 17: { active: false, title: 'Water ski', name: 'water_ski', opt: true, cph: false, price: '', secondLabel: '€' },

  // =============== static data ================
  let boatTypes = [
    "Boat Type",
    "Sear Ray",
    "Chris Craft",
    "Azimut Cedan",
    "Sear Ray",
    "Chris Craft",
    "Sear Ray",
    "Chris Craft",
    "Azimut Cedan",
  ];
  // =============== static data ================
  let manufacturerList = [
    "Related to previous",
    "Some option",
    "Some option",
    "Some option",
    "Some option",
  ];
  // =============== static data ================
  let modelList = [
    "Related to previous",
    "Some option",
    "Some option",
    "Some option",
    "Some option",
  ];
  // =============== static data ================
  let locationList = [
    { name: "Athens", id: 0 },
    { name: "Mykonos", id: 1 },
    { name: "Corfu", id: 2 },
    { name: "Lefkada", id: 3 },
    { name: "Tinos", id: 4 },
  ];
  // =============== static data ================
  let fuelList = [
    "Choose",
    "Some option",
    "Some option",
    "Some option",
    "Some option",
  ];

  // select gallery Image
  function selectImg(e, num) {
    let files = [];
    e.preventDefault();
    files = e.target.files;
    if (files.length > 0) {
      setFormData({
        ...formData,
        gallery_imgs: {
          ...formData.gallery_imgs,
          [num]: files[0],
        },
      });
    }
  }

  // remove selected Image
  const removeImg = (e, num) => {
    setFormData({
      ...formData,
      gallery_imgs: {
        ...formData.gallery_imgs,
        [num]: {},
      },
    });
  };

  // add New Image Box
  const addNewImageSpot = () => {
    let prevImgsLength = Object.keys(formData.gallery_imgs).length;
    if (prevImgsLength < 15) {
      setFormData({
        ...formData,
        gallery_imgs: {
          ...formData.gallery_imgs,
          [prevImgsLength]: {},
        },
      });
    } else {
      set_notify({
        open: true,
        type: "info",
        msg: "Maximum 15 images are allowed.",
      });
    }
  };

  // select/Pick other file/doc etc
  function selectOtherFiles(e) {
    e.preventDefault();
    let files = [];
    let reader;
    files = e.target.files;
    reader = new FileReader();
    reader.onload = function () {
      setFormData({
        ...formData,
        insurance_file: files[0],
      });
    };
    reader.readAsDataURL(files[0]);
  }

  // remove other file
  const removeInsuranceFile = () => {
    setFormData({
      ...formData,
      insurance_file: null,
    });
  };

  // file size calculator
  function bytesToSize(bytes) {
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "n/a";
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    if (i === 0) return `${bytes} ${sizes[i]})`;
    return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
  }

  // remove image box
  // const removeImgBox = (e,num) => {
  //     let newData = Object.values(formData.gallery_imgs);
  //     console.log(newData.splice(0, num));
  //     // setFormData({
  //     //     ...formData,
  //     //     gallery_imgs: {
  //     //         ...formData.gallery_imgs,
  //     //         [num]: files[0]
  //     //     }
  //     // })
  //     // console.log(newData)
  // }

  const addNewSuggest = (data, state) => {
    let dataLength = Object.values(data)?.length;
    state({
      ...data,
      [dataLength]: {
        title: "Suggest Feature",
        name: "suggest_feature",
        input: true,
        input_value: "",
        suggest_feature: true,
      },
    });
  };
  //======================= All Steps ==================================
  const steps = [
    null,
    <Step1
      formData={formData}
      setFormData={setFormData}
      addNewImageSpot={addNewImageSpot}
      boatTypes={boatTypes}
      selectImg={selectImg}
      removeImg={removeImg}
      selectOtherFiles={selectOtherFiles}
      removeInsuranceFile={removeInsuranceFile}
      loading={loading}
      bytesToSize={bytesToSize}
      manufacturerList={manufacturerList}
      modelList={modelList}
      locationList={locationList}
      fuelList={fuelList}
    />,
    <Step2
      formData={formData}
      setFormData={setFormData}
      featuresDataList={featuresDataList}
      setFeaturesList={setFeaturesList}
      luxury_dataList={luxury_dataList}
      luxury_featuresList={luxury_featuresList}
      setLuxury_FeaturesList={setLuxury_FeaturesList}
      featuresList={featuresList}
      addNewSuggest={addNewSuggest}
    />,
    <Step3
      formData={formData}
      setFormData={setFormData}
      opt_cph_={opt_cph_}
      set_opt_cph_={set_opt_cph_}
    />,
    <Step4 formData={formData} setFormData={setFormData} />,
  ];

  //========================= steps numbers clickable  ====================
  const handleDirectPaging = (his_num) => {
    setActiveStep(his_num + 1);
  };

  //============================= Steps change next & prev according to type will pass ====================
  const handleStepChange = (type) => {
    if (type === "next") {
      if (activeStep + 1 <= steps.length - 1) {
        setActiveStep(activeStep + 1);
        window.scrollTo(0, 0);
      }
    }
    if (type === "prev") {
      if (activeStep - 1 > 0) {
        setActiveStep(activeStep - 1);
        window.scrollTo(0, 0);
      }
    }
    if (type === "cancel") {
      setActiveStep(1);
      window.scrollTo(0, 0);
    }
  };

  // check user is logged in or not
  if (props.current_user && props.current_user?.isAuth) {
    //================= if user is captain ================
    if (props.current_user?.is_captain) {
      return (
        <section id="add_newBoat_page">
          <div className="cs_container">
            <div className="page-back-sec">
              <button
                onClick={() => props.history.goBack()}
                className="page-back-btn"
              >
                <ArrowBack />
              </button>
              <div className="page-name">
                <h5 className="text-pr">Add new Boat</h5>
              </div>
            </div>
            <div className="cs-timeline">
              {steps.slice(1, steps.length).map((step, i) => {
                return (
                  <div
                    onClick={() => handleDirectPaging(i)}
                    key={i}
                    className={`
                                        ${
                                          activeStep > i ? "" : "step-disabled"
                                        } 
                                        ${
                                          activeStep > i + 1
                                            ? "passed-step"
                                            : ""
                                        } 
                                        
                                        cs-step`}
                  >
                    {i + 1}
                  </div>
                );
              })}
            </div>
            {/* form starts */}
            {steps[activeStep]}
            {/* step bottom buttons */}
            <div className="add-listing-footer">
              {activeStep === steps.length - 1 && (
                <div className="add-listing-user-note">
                  <p>
                    By selecting the button below, I agree to the{" "}
                    <span className="text-pr text-uppercase">
                      {" "}
                      CYAN Rules.{" "}
                    </span>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Donec vestibulum congue dolor nunc amet.
                  </p>
                </div>
              )}
              <div className="step-bottom-btns-wraps">
                <Link
                  to="/"
                  // onClick={() => handleStepChange('cancel')}
                  className="step-next-prev-btn cancel-stp-btn"
                >
                  Cancel
                </Link>
                <button
                  onClick={() => handleStepChange("prev")}
                  className={`step-next-prev-btn prev-stp-btn ${
                    activeStep > 1 ? "" : "stp-btn-disabled"
                  } `}
                >
                  Previous
                </button>
                {/* <button
                                    onClick={() => handleStepChange('next')}
                                    className={`${activeStep === steps.length ? 'stp-btn-disabled' : ''} step-next-prev-btn next-stp-btn`}>
                                    Preview Listing
                                </button> */}
                <div className="add-listing-next-preview-btn-box">
                  {activeStep === steps.length - 1 && (
                    <button className={`step-next-prev-btn preview-stp-btn`}>
                      Preview Listing
                    </button>
                  )}
                  <button
                    onClick={() => handleStepChange("next")}
                    className={`${
                      activeStep === steps.length - 1 ? "stp-btn-disabled" : ""
                    } step-next-prev-btn next-stp-btn`}
                  >
                    {activeStep === steps.length - 1 ? "Add Boat" : "Next"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    } else {
      // else only captain profile user can access this page
      return (
        <>
          <CustomModel openPopup={showPopup} setOpenPopup={setShowPopup}>
            <SiginInPopup closeModel={setShowPopup} />
          </CustomModel>
          <div className="container header-spacer my-5 py-5">
            <div className="row">
              <div className="col-12 mx-auto text-center">
                <p>You need to have an captain profile to view this page</p>
                <br />
                <div className="d-flex justify-content-center align-items-center flex-wrap w-100">
                  <Button
                    component={Link}
                    className="mx-4"
                    to="/signup"
                    variant="contained"
                    color="primary"
                  >
                    Sign up
                  </Button>
                  <Button
                    onClick={() => setShowPopup(true)}
                    className="my-4"
                    variant="outlined"
                    color="primary"
                  >
                    Login with captain profile
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }
  } else {
    //======= not logged in =========
    return <NotLoggedIn />;
  }
};

// =============================================================
// STEP #01
const Step1 = ({
  formData,
  setFormData,
  addNewImageSpot,
  boatTypes,
  selectImg,
  removeImg,
  selectOtherFiles,
  removeInsuranceFile,
  loading,
  bytesToSize,
  manufacturerList,
  modelList,
  locationList,
  fuelList,
}) => {
  return (
    <div className="step-form-row">
      <div className="step-form-left">
        <div className="step-heading">
          <h4>Basic Information</h4>
        </div>
        <div className="row my-4">
          <div className="col-md-11">
            <div className="main-input d-flex my-1 justify-content-between align-items-center">
              <div className="profile-labels add-list-all-labels text-left ">
                <label htmlFor="">Boat Name</label>
              </div>
              <div className="profile-inputs-wrapper">
                <CustomInput
                  name="boat_name"
                  blueborder={"true"}
                  placeholder="Hint. A marketing friendly boat name"
                  // onChange={(e)=> handlePersonalForm(e)} value={data.first_name}
                />
              </div>
            </div>
            <div className="main-input d-flex my-1 justify-content-start align-items-center">
              <div className="profile-labels add-list-all-labels text-left ">
                <label htmlFor="">Boat type</label>
              </div>
              <div className="profile-inputs-wrapper">
                <div className="cs-select-box">
                  <div className="cs-select">
                    <select className="cs-select" name="boat_type" id="">
                      {boatTypes.map((value, i) => (
                        <option
                          disabled={i === 0 ? true : false}
                          selected={i === 0 ? true : false}
                          key={i}
                          value={i}
                        >
                          {value}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="main-input d-flex my-1 justify-content-start align-items-center">
              <div className="profile-labels add-list-all-labels text-left ">
                <label htmlFor="">Manufacturer</label>
              </div>
              <div className="profile-inputs-wrapper">
                {/* <div className="cs-select-box">
                                    <div className="cs-select">
                                        <select className="cs-select" name="manufacturer" id="">
                                            {manufacturerList.map((value, i) => (
                                                <option disabled={i === 0 ? true : false} selected={i === 0 ? true : false} key={i} value={i}>{value}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div> */}
                <CustomInput
                  name="manufacturer"
                  blueborder={"true"}
                  placeholder="Enter"
                  // onChange={(e)=> handlePersonalForm(e)} value={data.first_name}
                />
              </div>
            </div>
            <div className="main-input d-flex my-1 justify-content-start align-items-center">
              <div className="profile-labels add-list-all-labels text-left ">
                <label htmlFor="">Model</label>
              </div>
              <div className="profile-inputs-wrapper">
                {/* <div className="cs-select-box">
                                    <div className="cs-select">
                                        <select className="cs-select" name="model" id="">
                                            {modelList.map((value, i) => (
                                                <option disabled={i === 0 ? true : false} selected={i === 0 ? true : false} key={i} value={i}>{value}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div> */}
                <CustomInput
                  name="model"
                  blueborder={"true"}
                  placeholder="Enter"
                  // onChange={(e)=> handlePersonalForm(e)} value={data.first_name}
                />
              </div>
            </div>
            <div className="main-input d-flex my-1 justify-content-between align-items-center">
              <div className="profile-labels add-list-all-labels text-left ">
                <label htmlFor="">Year Built</label>
              </div>
              <div className="profile-inputs-wrapper">
                <CustomInput
                  className="text-center"
                  name="year_built"
                  blueborder={"true"}
                  placeholder="YYYY"
                  // onChange={(e)=> handlePersonalForm(e)} value={data.first_name}
                />
              </div>
            </div>
            <div className="main-input d-flex my-1 justify-content-start align-items-center">
              <div className="profile-labels add-list-all-labels text-left ">
                <label htmlFor="">Location</label>
              </div>
              <div className="profile-inputs-wrapper">
                <div className="cs-select-box">
                  <div className="cs-select">
                    <select className="cs-select" name="location_name" id="">
                      {locationList.map((value, i) => (
                        <option key={i} value={value?.name}>
                          {value?.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="main-input d-flex my-1 justify-content-between align-items-center">
              <div className="profile-labels add-list-all-labels text-left ">
                <label htmlFor="">Marina</label>
              </div>
              <div className="profile-inputs-wrapper">
                <CustomInput
                  name="marina"
                  blueborder={"true"}
                  placeholder="Enter"
                  // onChange={(e)=> handlePersonalForm(e)} value={data.first_name}
                />
              </div>
            </div>
            {/* <div className="main-input d-flex my-1 justify-content-between align-items-center">
                            <div className="profile-labels add-list-all-labels text-left "><label htmlFor="">Guests</label></div>
                            <div className="profile-inputs-wrapper ">
                                <CustomInput name="guests" blueborder={"true"} placeholder="Alex.Jonson@gmail.com"
                                // onChange={(e)=> handlePersonalForm(e)} value={data.first_name} 
                                />
                            </div>
                        </div> */}
            <div className="main-input d-flex my-1 justify-content-between align-items-center">
              <div className="profile-labels add-list-all-labels text-left ">
                <label htmlFor="">Guests</label>
              </div>
              <div className="profile-inputs-wrapper mid-input">
                <CustomInput
                  name="guests"
                  blueborder={"true"}
                  placeholder="0"
                  type="number"
                  // onChange={(e)=> handlePersonalForm(e)} value={data.first_name}
                />
              </div>
              <div className="mid-label px-1 text-center ">
                <label htmlFor="">Beds</label>
              </div>
              <div className="profile-inputs-wrapper mid-input">
                <CustomInput
                  name="guests"
                  blueborder={"true"}
                  placeholder="0"
                  type="number"
                  // onChange={(e)=> handlePersonalForm(e)} value={data.first_name}
                />
              </div>
            </div>
            <div className="main-input d-flex my-1 justify-content-between align-items-center">
              <div className="profile-labels add-list-all-labels text-left ">
                <label htmlFor="">Cabins</label>
              </div>
              <div className="profile-inputs-wrapper mid-input">
                <CustomInput
                  name="guests"
                  blueborder={"true"}
                  placeholder="0"
                  type="number"
                  // onChange={(e)=> handlePersonalForm(e)} value={data.first_name}
                />
              </div>
              {/* <div className="mid-label px-3 text-center ">
                <label htmlFor="">Kitchen</label>
              </div>
              <div className="profile-inputs-wrapper mid-input">
                <CustomInput
                  name="guests"
                  blueborder={"true"}
                  placeholder="0"
                  type="number"
                  // onChange={(e)=> handlePersonalForm(e)} value={data.first_name}
                />
              </div> */}
            </div>
            <div className="main-input d-flex my-1 justify-content-between align-items-center">
              <div className="profile-labels add-list-all-labels text-left ">
                <label htmlFor="">Bathrooms</label>
              </div>
              <div className="profile-inputs-wrapper">
                <CustomInput
                  name="bathrooms"
                  blueborder={"true"}
                  placeholder="Enter"
                  // onChange={(e)=> handlePersonalForm(e)} value={data.first_name}
                />
              </div>
            </div>
            <div className="main-input d-flex my-1 justify-content-start align-items-center">
              <div className="profile-labels add-list-all-labels text-left ">
                <label htmlFor="">Length</label>
              </div>
              {/* <div className="ad-boat-length-box">
                                <CustomInput type="number" className="sm-input-length" name="guests" blueborder={"true"} placeholder="0"
                                // onChange={(e)=> handlePersonalForm(e)} value={data.first_name} 
                                />
                                <span className='secondary-label'>Feet</span>
                            </div>
                            <div className="input-or text-center d-flex justify-content-center align-items-center px-2">
                                or
                            </div> */}
              <div className="profile-inputs-wrapper mid-input">
                <CustomInput
                  type="number"
                  className="sm-input-length"
                  name="guests"
                  blueborder={"true"}
                  placeholder="0"
                  // onChange={(e)=> handlePersonalForm(e)} value={data.first_name}
                />
              </div>
              <span className="secondary-label">meters</span>
            </div>
            <div className="main-input d-flex my-1 justify-content-start align-items-center">
              <div className="profile-labels add-list-all-labels text-left ">
                <label htmlFor="">Fuel type</label>
              </div>
              <div className="profile-inputs-wrapper">
                <div className="cs-select-box">
                  <div className="cs-select">
                    <select className="cs-select" name="boat_type" id="">
                      {fuelList.map((value, i) => (
                        <option
                          disabled={i === 0 ? true : false}
                          selected={i === 0 ? true : false}
                          key={i}
                          value={i}
                        >
                          {value}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="main-input d-flex my-1 justify-content-between align-items-center">
              <div className="profile-labels add-list-all-labels text-left ">
                <label htmlFor="">Cruising Speed</label>
              </div>
              <div className="profile-inputs-wrapper">
                <CustomInput
                  name="engine"
                  blueborder={"true"}
                  placeholder="Enter"
                  // onChange={(e)=> handlePersonalForm(e)} value={data.first_name}
                />
              </div>
            </div>

            <div className="main-input d-flex my-1 justify-content-start align-items-center">
              <div className="profile-labels add-list-all-labels text-left ">
                <label htmlFor="">Price per day</label>
              </div>
              <div className="profile-inputs-wrapper">
                <CustomInput
                  type="number"
                  // className="sm-input-length"
                  name="price_per_day"
                  blueborder={"true"}
                  placeholder="Enter"
                  // onChange={(e)=> handlePersonalForm(e)} value={data.first_name}
                />
              </div>
            </div>

            {/* <div className="d-flex mt-3 justify-content-between align-items-center">
                            <span className="fw-bold">Pets allowed</span>
                            <div className="d-flex justify-content-end align-items-center">

                                <div className="cs-switch-container">
                                    <label className="cs-switch ad-list-switch" htmlFor="checkbox1">
                                        <input checked={formData.pets_allowed}
                                            onChange={(e) => setFormData({ ...formData, pets_allowed: e.target.checked })}
                                            className="switch-checkbox" type="checkbox" id="checkbox1" />
                                        <div className="cs-switch-slider switch-round"></div>
                                    </label>
                                </div>
                                <span className="">&nbsp; &nbsp;{formData.pets_allowed ? "Yes" : "No"}</span>
                            </div>
                        </div>
                        <div className="d-flex mt-3 justify-content-between align-items-center">
                            <span className="fw-bold">Parties allowed</span>
                            <div className="d-flex justify-content-end align-items-center">

                                <div className="cs-switch-container">
                                    <label className="cs-switch ad-list-switch" htmlFor="checkbox2">
                                        <input checked={formData.parties_allowed}
                                            onChange={(e) => setFormData({ ...formData, parties_allowed: e.target.checked })}
                                            className="switch-checkbox" type="checkbox" id="checkbox2" />
                                        <div className="cs-switch-slider switch-round"></div>
                                    </label>
                                </div>
                                <span className="">&nbsp; &nbsp;{formData.parties_allowed ? "Yes" : "No"}</span>
                            </div>
                        </div>
                        <div className="d-flex mt-3 justify-content-between align-items-center">
                            <span className="fw-bold">Crew</span>
                            <div className="d-flex justify-content-end align-items-center">

                                <div className="cs-switch-container">
                                    <label className="cs-switch ad-list-switch" htmlFor="checkbox3">
                                        <input checked={formData.crew_allowed}
                                            onChange={(e) => setFormData({ ...formData, crew_allowed: e.target.checked })}
                                            className="switch-checkbox" type="checkbox" id="checkbox3" />
                                        <div className="cs-switch-slider switch-round"></div>
                                    </label>
                                </div>
                                <span className="">&nbsp; &nbsp;{formData.crew_allowed ? "Yes" : "No"}</span>
                            </div>
                        </div> */}
          </div>
        </div>
      </div>
      <div className="step-form-right">
        <div className="step-heading">
          <h4>Gallery</h4>
        </div>
        <div className="upload-gallery-sec">
          <div className="add-boat-gallery-top">
            <span>Up to 15 photos</span>{" "}
            <button onClick={addNewImageSpot}>
              <img src={PlusImg} alt="" />
            </button>
          </div>
          <div className="gallery-img-row">
            {/* {console.log(formData?.gallery_imgs)} */}
            {Object.values(formData.gallery_imgs)?.map((imgData, index) => {
              return (
                <PickImageBtn
                  loading={loading}
                  num={index}
                  selectImg={(e) => selectImg(e, index)}
                  deleteImage={(e) => removeImg(e, index)}
                  // removeImgBox={(e) => removeImgBox(e, index)}
                  imgSrc={imgData}
                  srcAvail={typeof imgData === "string" ? true : false}
                  key={index}
                  primaryImg={index === 0 ? true : false}
                />
              );
            })}
          </div>
        </div>
        <div className="step-heading mt-4">
          <h4>Description</h4>
        </div>
        <div className="boat-desc-wrappper">
          <textarea
            onChange={(e) =>
              setFormData({
                ...formData,
                description: e.target.value,
              })
            }
            value={formData.description}
            placeholder="Describe here..."
            name="description"
          />
          <div className="boat-desc-count d-flex justify-content-end align-items-center mt-2">
            <span className="text-sec">
              {formData?.description?.trim().length}/500
            </span>
          </div>
        </div>
        <div className="step-heading mt-md-4 mt-2">
          <h4>Brochure</h4>
        </div>
        <div className="file-choose-wrapper">
          <label htmlFor="insurance_cert" className="custom-file-upload">
            Choose file
          </label>
          <input
            onChange={selectOtherFiles}
            name="insurance_cert"
            id="insurance_cert"
            type="file"
          />
          <span id="file-details">
            {formData?.insurance_file && formData.insurance_file?.name
              ? formData.insurance_file?.name
              : "*No file chosen"}
          </span>
          <span className="file-size">
            {formData?.insurance_file && formData.insurance_file?.name ? (
              <>Size: {bytesToSize(formData.insurance_file?.size)}</>
            ) : null}
          </span>
          {formData?.insurance_file && formData.insurance_file?.name && (
            <div className="remove-other-file" onClick={removeInsuranceFile}>
              <Close />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
// ==============================================================

// =====================================================
// STEP #02
const Step2 = ({
  formData,
  setFormData,
  // featuresDataList,
  // luxury_dataList,
  luxury_featuresList,
  setLuxury_FeaturesList,
  featuresList,
  setFeaturesList,
  addNewSuggest,
}) => {
  return (
    <div className="step-form-row">
      <div className="step-form-left">
        <div className="step-heading">
          <h4>Features</h4>
        </div>
        <div className="features-row d-flex">
          {Object.values(featuresList).map((feature, ind) => (
            <div
              key={ind}
              className={`features-col ${
                feature.suggest_feature ? "features-col-full" : ""
              }`}
            >
              <div className="add-boat-checkbox d-flex justify-content-start align-items-center">
                <label
                  // htmlFor={feature.name}
                  className="checkbox-button "
                >
                  {feature.icon ? (
                    <div
                      style={{ width: "38px", textAlign: "center" }}
                      className="d-inline-block pe-2"
                    >
                      {feature.icon}
                    </div>
                  ) : feature.img ? (
                    <div
                      style={{ width: "38px", textAlign: "center" }}
                      className="d-inline-block pe-2"
                    >
                      <img src={feature.img} alt="" />
                    </div>
                  ) : null}
                  <input
                    checked={feature.input}
                    onChange={(e) => {
                      setFeaturesList({
                        ...featuresList,
                        [ind]: {
                          ...featuresList[ind],
                          input: e.target.checked,
                          input_value: "",
                        },
                      });
                    }}
                    type="checkbox"
                    className="checkbox-button__input"
                    // id={feature.name}
                    // name={feature.name}
                  />
                  <span className="checkbox-button__control"></span>
                  <span
                    className={`checkbox-button__label ad-list-chkboxlablel ${
                      feature.input ? "text-sec" : "text-gr"
                    }`}
                  >
                    {feature.title}
                  </span>
                </label>
                {feature.suggest_feature && (
                  <input
                    readOnly={!feature.input}
                    className={`extra-input ${
                      feature.input ? "" : "disabled-extra-in"
                    }`}
                    type="text"
                    onChange={(e) => {
                      setFeaturesList({
                        ...featuresList,
                        [ind]: {
                          ...featuresList[ind],
                          input_value: e.target.value,
                        },
                      });
                    }}
                    value={feature.input_value ? feature.input_value : ""}
                    // name={feature.name}
                    placeholder="Enter"
                    id=""
                  />
                )}
              </div>
            </div>
          ))}
          {/* <div className="features-col">
            <button
              className="cs_btn"
              onClick={() => addNewSuggest(featuresList, setFeaturesList)}
            >
              Suggest Another Feature
            </button>
          </div> */}
        </div>
      </div>
      <div className="step-form-right">
        <div className="step-heading">
          <h4>Luxurious features</h4>
        </div>
        <div className="features-row d-flex">
          {Object.values(luxury_featuresList).map((feature, ind) => (
            <div
              key={ind}
              className={`features-col ${
                feature.suggest_feature ? "features-col-full" : ""
              }`}
            >
              <div className="add-boat-checkbox d-flex justify-content-start align-items-center">
                <label
                  // htmlFor={feature.name}
                  className="checkbox-button "
                >
                  {feature.icon ? (
                    <div
                      style={{ width: "38px", textAlign: "center" }}
                      className="d-inline-block pe-2"
                    >
                      {feature.icon}
                    </div>
                  ) : feature.img ? (
                    <div
                      style={{ width: "38px", textAlign: "center" }}
                      className="d-inline-block pe-2"
                    >
                      <img src={feature.img} alt="" />
                    </div>
                  ) : null}
                  <input
                    checked={feature.input}
                    onChange={(e) => {
                      setLuxury_FeaturesList({
                        ...luxury_featuresList,
                        [ind]: {
                          ...luxury_featuresList[ind],
                          input: e.target.checked,
                          input_value: "",
                        },
                      });
                    }}
                    type="checkbox"
                    className="checkbox-button__input"
                    // id={feature.name}
                    // name={feature.name}
                  />
                  <span className="checkbox-button__control"></span>
                  <span
                    className={`checkbox-button__label ad-list-chkboxlablel ${
                      feature.input ? "text-sec" : "text-gr"
                    }`}
                  >
                    {feature.title}
                  </span>
                </label>
                {feature.suggest_feature && (
                  <input
                    readOnly={!feature.input}
                    className={`extra-input ${
                      feature.input ? "" : "disabled-extra-in"
                    }`}
                    type="text"
                    onChange={(e) => {
                      setLuxury_FeaturesList({
                        ...luxury_featuresList,
                        [ind]: {
                          ...luxury_featuresList[ind],
                          input_value: e.target.value,
                        },
                      });
                    }}
                    value={feature.input_value ? feature.input_value : ""}
                    // name={feature.name}
                    placeholder="Enter"
                    id=""
                  />
                )}
              </div>
            </div>
          ))}
          {/* <div
                key={ind}
                className={`features-col ${
                  feature.suggest_feature ? "features-col-full" : ""
                }`}
              >
                <div className="add-boat-checkbox d-flex justify-content-start align-items-center">
                  <label htmlFor={feature.name} className="checkbox-button">
                    <input
                      checked={luxury_featuresList?.[feature.name]}
                      onChange={(e) => {
                        setLuxury_FeaturesList({
                          ...luxury_featuresList,
                          [feature.name]: e.target.checked,
                          suggest_feature: "",
                        });
                      }}
                      type="checkbox"
                      className="checkbox-button__input"
                      id={feature.name}
                      name={feature.name}
                    />
                    <span className="checkbox-button__control"></span>
                    <span
                      className={`checkbox-button__label  ad-list-chkboxlablel ${
                        feature.input
                          ? luxury_featuresList?.[feature.name]
                            ? "text-sec"
                            : "text-gr"
                          : "text-sec"
                      } `}
                    >
                      {feature.title}
                    </span>
                  </label>
                  {feature.input && (
                    <input
                      className={`extra-input ${
                        luxury_featuresList?.[feature.name]
                          ? ""
                          : "disabled-extra-in"
                      }`}
                      readOnly={!luxury_featuresList?.[feature.name]}
                      type="text"
                      onChange={(e) => {
                        setLuxury_FeaturesList({
                          ...luxury_featuresList,
                          suggest_feature: e.target.value,
                        });
                      }}
                      value={
                        luxury_featuresList?.[feature.name]
                          ? luxury_featuresList["suggest_feature"]
                          : ""
                      }
                      name={"suggest_feature"}
                      placeholder="Enter"
                      id=""
                    />
                  )}
                </div>
              </div> */}
          {/* <div className="features-col">
            <button
              className="cs_btn"
              onClick={() =>
                addNewSuggest(luxury_featuresList, setLuxury_FeaturesList)
              }
            >
              Suggest Another Feature
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};
// ====================================================

// ===================================================
// STEP #03
const Step3 = ({ formData, setFormData, opt_cph_, set_opt_cph_ }) => {
  return (
    <div className="step-form-row no-middle-line">
      <div className="step-form-left step-form-75-left">
        <div className="step-heading">
          <h4>Extras</h4>
        </div>
        <div className="otp-cph-top-head">
          <div>
            <li>OTP:</li>
            <span className="text-sec px-1">One time payment</span>
          </div>
          <div>
            <li>CPD:</li>
            <span className="text-sec px-1">Cost per day</span>
          </div>
        </div>
        <div className="otp-cph-row">
          {Object.values(opt_cph_).map((item, ind) => (
            <div key={ind} className="otp-cph-wrapper">
              {item.suggest_feature ? (
                <>
                  <div className="opt-cph-col-1">
                    <label htmlFor={item.name} className="checkbox-button">
                      <input
                        checked={item.active}
                        onChange={(e) => {
                          set_opt_cph_({
                            ...opt_cph_,
                            [ind]: {
                              ...opt_cph_[ind],
                              active: e.target.checked,
                              input_value: "",
                            },
                          });
                        }}
                        type="checkbox"
                        className="checkbox-button__input"
                        id={item.name}
                        name={item.name}
                      />
                      <span className="checkbox-button__control"></span>
                      <span className="checkbox-button__label text-sec">
                        {item.title}
                      </span>
                    </label>
                  </div>
                  <input
                    readOnly={!item.active}
                    className={`extra-input ${
                      item.active ? "" : "disabled-extra-in"
                    }`}
                    type="text"
                    onChange={(e) => {
                      set_opt_cph_({
                        ...opt_cph_,
                        [ind]: {
                          ...opt_cph_[ind],
                          input_value: e.target.value,
                        },
                      });
                    }}
                    value={item.active ? item?.input_value : ""}
                    name={item.name}
                    placeholder="Enter"
                    id=""
                  />
                </>
              ) : (
                <>
                  <div className="opt-cph-col-1">
                    <label htmlFor={item.name} className="checkbox-button">
                      {item.icon ? (
                        <div
                          style={{ width: "43px", textAlign: "center" }}
                          className="d-inline-block pe-2"
                        >
                          {item.icon}
                        </div>
                      ) : item.img ? (
                        <div
                          style={{ width: "43px", textAlign: "center" }}
                          className="d-inline-block pe-2"
                        >
                          <img src={item.img} alt="" />
                        </div>
                      ) : null}
                      <input
                        checked={item.active}
                        onChange={(e) => {
                          set_opt_cph_({
                            ...opt_cph_,
                            [ind]: {
                              ...opt_cph_[ind],
                              active: e.target.checked,
                            },
                          });
                        }}
                        type="checkbox"
                        className="checkbox-button__input"
                        id={item.name}
                        name={item.name}
                      />
                      <span className="checkbox-button__control"></span>
                      <span className="checkbox-button__label text-sec">
                        {item.title}
                      </span>
                    </label>
                  </div>
                  <div className="opt-cph-col-2">
                    <div className="opt-cph--select-box">
                      <div
                        onClick={() =>
                          set_opt_cph_({
                            ...opt_cph_,
                            [ind]: {
                              ...opt_cph_[ind],
                              opt: true,
                              cph: false,
                            },
                          })
                        }
                        className={`otp-side ${
                          item.opt ? "active-opt-cph" : ""
                        }`}
                      >
                        OTP
                      </div>
                      <div
                        onClick={() =>
                          set_opt_cph_({
                            ...opt_cph_,
                            [ind]: {
                              ...opt_cph_[ind],
                              opt: false,
                              cph: true,
                            },
                          })
                        }
                        className={`cph-side ${
                          item.cph ? "active-opt-cph" : ""
                        }`}
                      >
                        CPD
                      </div>
                    </div>
                  </div>
                  <div className="opt-cph-col-3">
                    <div className="otp-cph-price-box">
                      <div className="label-for-otp-prices">Price</div>
                      <div className="input-for-otp-prices">
                        <input
                          type="number"
                          placeholder="0"
                          value={item?.input_value}
                          onChange={(e) => {
                            set_opt_cph_({
                              ...opt_cph_,
                              [ind]: {
                                ...opt_cph_[ind],
                                input_value: e.target.value,
                              },
                            });
                          }}
                        />
                      </div>
                      <div className="second-label-for-otp-prices">
                        {item.opt ? "€" : "€"}{" "}
                      </div>
                      {/* €/Per Hr */}
                    </div>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
      <div className="step-form-right"></div>
    </div>
  );
};
// ======================================================

// =======================================================
// STEP #04
const Step4 = ({ formData, setFormData }) => {
  const [dateState, setDateState] = useState({
    selection1: {
      startDate: new Date(),
      endDate: null,
      key: "selection1",
    },
    selection2: {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection2",
    },
    selection3: {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection3",
    },
    selection4: {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection4",
    },
  });

  const [dateState1, setDateState1] = useState({
    selection1: {
      startDate: new Date(),
      endDate: null,
      key: "selection1",
    },
    selection2: {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection2",
    },
    selection3: {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection3",
    },
    selection4: {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection4",
    },
  });
  return (
    <div className="step-form-row">
      <div className="step-form-left">
        <div className="step-heading">
          <h4>Cancellation Policy & Boat Availability</h4>
        </div>
        <div className="boat-avail-top-head">
          <h5>Boat Availability</h5>
        </div>
        {/* <div className="boat-avail-mode">
          <div className="boat-avail-intraday-and-overnight">
            <label htmlFor="intraday_checked" className="checkbox-button">
              <input
                checked={formData.intraDay}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    intraDay: e.target.checked,
                  });
                }}
                type="checkbox"
                className="checkbox-button__input"
                id="intraday_checked"
                name="intraDay"
              />
              <span className="checkbox-button__control"></span>
              <span className="checkbox-button__label ">Fullday</span>
            </label>
          </div>
          <div className="min-hours-add-list">
            <label htmlFor="">Check-in Time &nbsp; </label>
            <input type="time" value="00:00" />
          </div>
          <div className="min-hours-add-list">
            <label htmlFor="">Check-out Time </label>
            <input type="time" value="00:00" />
          </div>
        </div> */}
        <div className="boat-avail-mode">
      
          {/* <div className="boat-avail-intraday-and-overnight">
            <label htmlFor="over_checked" className="checkbox-button">
              <input
                checked={formData.overNight}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    overNight: e.target.checked,
                  });
                }}
                type="checkbox"
                className="checkbox-button__input"
                id="over_checked"
                name="overNight"
              />
              <span className="checkbox-button__control"></span>
              <span className="checkbox-button__label ">Overnight</span>
            </label>
          </div> */}
          <div className="min-hours-add-list">
          <p className="fw-light">
          Choose Check-in/out times and Minimum days of booking
          </p>
          <br />
            <label htmlFor="">Check-in Time &nbsp; </label>
            <input type="time" value="00:00" />
          </div>
          <div className="min-hours-add-list">
            <label htmlFor="">Check-out Time </label>
            <input type="time" value="00:00" />
          </div>
          <div className="min-hours-add-list">
            <label htmlFor="">Minimum Days</label>
            <input type="number" value="7" />
          </div>
        </div>

        {/*  */}
        <div className="with-left-border  mt-md-5 mt-4">
          <h5 className="px-1 text-muted">Booking Policy</h5>
          <div className="boat-desc-wrappper mt-2 px-0 mx-0 pt-0 mid-height">
            <textarea
              placeholder="Enter here"
              name=""
              id=""
              rows="3"
              className="my-0"
            ></textarea>
            <div className="boat-desc-count d-flex justify-content-between align-items-center mt-2">
              {/* <span className="text-danger mt-0">
                {errors?.description?.msg}
              </span> */}
              <span></span>
              <span className="text-sec me-auo">
                {/* {formData?.description?.trim().length} */}
                0/500
              </span>
            </div>
          </div>
        </div>
        {/* <div className="add-list-booking-policy-sec mt-md-5 pt-md-5 px-2">
          <h5 className="text-gr">
            Booking Policies for Intraday and/or Overnight
          </h5>
          <label htmlFor="flexible_intraDay" className="checkbox-button mt-4">
            <input
              checked={formData.flexible_intraDay}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  flexible_intraDay: formData.intraDay
                    ? true
                    : e.target.checked,
                });
              }}
              type="checkbox"
              className="checkbox-button__input"
              id="flexible_intraDay"
              name="flexible_intraDay"
            />
            <span className="checkbox-button__control"></span>
            <span className="checkbox-button__label text-sec font-weight-bold">
              Intraday
            </span>
          </label>
          <div className="flexible-wrapper">
            <div className="flexible-top-btns">
              <button
                onClick={() => {
                  setFormData({
                    ...formData,
                    intraday_flexible_mode: "0",
                  });
                }}
                className={`flexible-btn ${
                  formData.intraday_flexible_mode === "0"
                    ? " active-opt-cph"
                    : ""
                }`}
              >
                Flexible
              </button>
              <button
                onClick={() => {
                  setFormData({
                    ...formData,
                    intraday_flexible_mode: "1",
                  });
                }}
                className={`flexible-btn ${
                  formData.intraday_flexible_mode === "1"
                    ? " active-opt-cph"
                    : ""
                }`}
              >
                Semi-Flexible
              </button>
              <button
                onClick={() => {
                  setFormData({
                    ...formData,
                    intraday_flexible_mode: "2",
                  });
                }}
                className={`flexible-btn ${
                  formData.intraday_flexible_mode === "2"
                    ? " active-opt-cph"
                    : ""
                }`}
              >
                Strict
              </button>
            </div>
            <div className="flexible-botom-rgb-line">
              <div
                className={`${modeClass(
                  formData.intraday_flexible_mode
                )} flexible-inner`}
              ></div>
            </div>
          </div>
          <div className="user-flexible-note mt-5 mb-3">
            <p className="text-gr">
              <span className="text-dark">
                {formData.intraday_flexible_mode === "0" && "Flexible Policies"}
                {formData.intraday_flexible_mode === "1" && "Semi-Flexible"}
                {formData.intraday_flexible_mode === "2" && "Strict"}
                {" ->"}
              </span>{" "}
              After that, cancel before 3:00 PM on Oct 21th get full refund,
              minus first night and service fee
            </p>
          </div>
          <label htmlFor="flexible_overnight" className="checkbox-button mt-4">
            <input
              checked={formData.flexible_overnight}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  flexible_overnight: formData.overNight
                    ? true
                    : e.target.checked,
                });
              }}
              type="checkbox"
              className="checkbox-button__input"
              id="flexible_overnight"
              name="flexible_overnight"
            />
            <span className="checkbox-button__control"></span>
            <span className="checkbox-button__label text-sec font-weight-bold">
              Overnight
            </span>
          </label>
          <div className="flexible-wrapper">
            <div className="flexible-top-btns">
              <button
                onClick={() => {
                  setFormData({
                    ...formData,
                    overnight_flexible_mode: "0",
                  });
                }}
                className={`flexible-btn ${
                  formData.overnight_flexible_mode === "0"
                    ? " active-opt-cph"
                    : ""
                }`}
              >
                Flexible
              </button>
              <button
                onClick={() => {
                  setFormData({
                    ...formData,
                    overnight_flexible_mode: "1",
                  });
                }}
                className={`flexible-btn ${
                  formData.overnight_flexible_mode === "1"
                    ? " active-opt-cph"
                    : ""
                }`}
              >
                Semi-Flexible
              </button>
              <button
                onClick={() => {
                  setFormData({
                    ...formData,
                    overnight_flexible_mode: "2",
                  });
                }}
                className={`flexible-btn ${
                  formData.overnight_flexible_mode === "2"
                    ? " active-opt-cph"
                    : ""
                }`}
              >
                Strict
              </button>
            </div>
            <div className="flexible-botom-rgb-line">
              <div
                className={`${modeClass(
                  formData.overnight_flexible_mode
                )} flexible-inner`}
              ></div>
            </div>
          </div>
        </div> */}
      </div>
      <div className="step-form-right">
        <div className="boat-avail-top-head pt-md-5">
          <h5>Unavailable Days</h5>
        </div>
        <div className="unavail-calendar-wrapper">
          <p className="text-sec py-4">-Intraday</p>
          <div className="unavail-calendar-box">
            <div className="intradaycalender">
              <DateRangePicker
                onChange={(item) => setDateState1({ ...dateState1, ...item })}
                ranges={[
                  dateState1.selection1,
                  dateState1.selection2,
                  dateState1.selection3,
                  dateState1.selection4,
                ]}
                moveRangeOnFirstSelection={true}
                minDate={new Date()}
                selectsStart={true}
                inline={true}
              />
            </div>
          </div>
          <div className="w-100 text-center">
            <button className="step-next-prev-btn cancel-stp-btn mx-auto my-4">
              Update
            </button>
          </div>
          {/* <p className="text-sec py-4">-Overnight</p>
          <div className="unavail-calendar-box">
            <DateRangePicker
              onChange={(item) => setDateState({ ...dateState, ...item })}
              ranges={[
                dateState.selection1,
                dateState.selection2,
                dateState.selection3,
                dateState.selection4,
              ]}
              moveRangeOnFirstSelection={true}
              minDate={new Date()}
              selectsStart={true}
              inline={true}
            />
          </div> */}
        </div>
      </div>
    </div>
  );
};
// ======================================================

// redux config
const mapStateToProps = (store) => ({
  current_user: store.current_user,
});

export default connect(mapStateToProps, null)(withRouter(AddBoat));
